var galegoTranslation = {
    translations: {
        philippinePassport: "Pasaporte filipino",
        seamanBook: "Libro de marinero",
        philSysID: "Identificación PhilSys",
        iBP: "Colegio de Abogados Integrado de Filipinas (IBP)",
        driversLicense: "Licencia de conducir",
        loading: "Cargando...",
        loadingDataProvider: "Cargando o provedor de datos...",
        tallySheetImport: {
            title: "Importacións de actas de escrutinio",
            subtitle: "Importa ficheiros de actas de escrutinio ES&S ou CSV, previsualiza as urnas xeradas e apróbaas antes de crear actas de escrutinio.",
            createTitle: "Importar actas de escrutinio",
            detailTitle: "Importación de acta de escrutinio",
            empty: "Aínda non hai importacións de actas de escrutinio.",
            emptyBody: "Comeza importando un ficheiro ES&S Enhanced XML ou CSV canónico para este evento electoral.",
            sourceFormat: {
                ESS_ENHANCED_XML: "ES&S Enhanced XML",
                CANONICAL_CSV: "CSV canónico",
            },
            channel: {
                PAPER: "Papel",
                POSTAL: "Postal",
                IN_PERSON: "Presencial",
            },
            table: {
                created: "Creado",
                createdBy: "Creado por",
                file: "Ficheiro",
                format: "Formato",
                channel: "Canle",
                status: "Estado",
                labels: "Etiquetas",
                annotations: "Anotacións",
                actions: "Accións",
            },
            summary: {
                imported: "Importadas",
                changed: "Modificadas",
                new: "Novas",
                unchanged: "Sen cambios",
                conflicted: "En conflito",
                errors: "Erros",
            },
            status: {
                PENDING_REVIEW: "Pendente de revisión",
                APPROVED: "Aprobada",
                DISAPPROVED: "Desaprobada",
                FAILED_VALIDATION: "Validación fallida",
                CONFLICTED: "En conflito",
                NEW: "Nova",
                CHANGED: "Modificada",
                UNCHANGED: "Sen cambios",
            },
            fields: {
                format: "Formato",
                channel: "Canle",
                supportedFormats: "Formatos admitidos: XML, CSV",
                generatedTallySheet: "Acta de escrutinio xerada",
                sourceCandidates: "IDs de candidatos de orixe",
                none: "Ningún",
            },
            actions: {
                create: "Importar actas de escrutinio",
                review: "Revisar",
                source: "Orixe",
                cancel: "Cancelar",
                preview: "Previsualizar",
                save: "Gardar importación",
                approve: "Aprobar",
                disapprove: "Desaprobar",
                close: "Pechar",
                openExisting: "Abrir existente",
            },
            notifications: {
                selectFile: "Selecciona un ficheiro de importación antes de previsualizalo",
                duplicateSource: "Este hash de ficheiro de orixe xa aparece nunha importación de acta de escrutinio anterior.",
                uploadUrlError: "Non se puido crear a URL de subida",
                uploadError: "Non se puido subir o ficheiro de importación",
                previewEmpty: "A resposta da previsualización estaba baleira",
                previewError: "Non se puido previsualizar a importación",
                importEmpty: "A resposta da importación estaba baleira",
                created: "Creouse a importación da acta de escrutinio",
                createError: "Non se puido crear a importación",
                reviewEmpty: "A resposta da revisión estaba baleira",
                conflicted: "A importación ten conflitos de liña base desactualizados",
                approved: "Aprobouse a importación",
                disapproved: "Desaprobouse a importación",
                reviewError: "Non se puido revisar a importación",
                sourceUrlError: "Non se puido crear a URL de descarga de orixe",
                sourceDownloadError: "Non se puido descargar o ficheiro de orixe",
            },
            pagination: {
                range: "{{rangeStart}}-{{rangeEnd}} de {{total}}",
                previous: "Anterior",
                next: "Seguinte",
            },
        },
        reconciliation: {
            menuButton: "Sincr. votantes ext.",
            categories: {
                VOTED_INTERNET: "Votou por Internet",
                VOTED_OTHER_CHANNEL: "Votou por outra canle",
                DISABLED_DELETE_CALL: "Votante desactivado",
                DELETION_REVERTED: "Eliminación revertida",
                PROFILE_UPDATE: "Perfil actualizado",
                VOTER_ADDED: "Votante engadido",
                REENABLED: "Votante reactivado",
                VOTED_UNMARKED: "Votante desmarcado como votante",
                ROW_FAILURE: "Erro de fila",
            },
            table: {
                voterId: "ID de Votante",
                field: "Campo",
                category: "Categoría",
                currentValue: "Valor actual",
                newValue: "Valor novo",
                reason: "Motivo",
                rowLabel: "Fila",
                noDifferences: "Non se atoparon diferenzas - os sistemas están sincronizados.",
            },
            wizard: {
                title: "Sincronización de reconciliación externa",
                subtitle: "Sincroniza a lista de votantes co sistema externo",
                drop: {
                    description: "Solta o ficheiro de reconciliación xerado polo sistema externo - ambos os diffs (lado externo e lado Sequent) calcúlanse automaticamente e móstranse en táboas separadas.",
                    fileFormatLabel: "Ficheiro CSV",
                    uploading: "Subindo {{fileName}} e calculando ambos os diffs...",
                },
                review: {
                    fileSummary: "{{fileName}} - Secuencia {{sequence}}, xerado {{generatedAt}}",
                    rowFailuresWarning: "{{count}} fila(s) non se puideron reconciliar de forma segura e quedan excluídas de ambos os diffs - ver detalles abaixo.",
                    noDifferences: "Non hai diferenzas - ambos os sistemas xa están sincronizados.",
                    diffOnlyDifferences: "Esta é unha comprobación de converxencia dunha secuencia xa aplicada. As diferenzas móstranse para o seu seguimento, pero esta rolda non se pode volver aplicar.",
                    externalDiffTitle: "Diff externo",
                    sequentDiffTitle: "Diff de Sequent",
                    downloadExternalPatch: "Descargar parche externo",
                    externalDiffCaption: "Descarga o parche e entrégao ao sistema externo fóra desta ferramenta. Unha vez que o aplique e xere o seguinte ficheiro de reconciliación, preme en 'Atrás' e solta ese ficheiro - 'Aplicar' actívase cando esta táboa estea baleira.",
                    noExternalDifferences: "Non hai diferenzas do lado externo.",
                    sequentDiffCaption: "Aplica os cambios directamente a Sequent premendo en 'Aplicar' - non se xera ficheiro de parche para estes.",
                    noSequentDifferences: "Non hai diferenzas do lado de Sequent.",
                },
                applying: {
                    inProgress: "Aplicando os cambios do lado de Sequent...",
                    rowFailures: "{{count}} fila(s) quedaron excluídas desta ronda e precisan seguimento manual - ver detalles abaixo.",
                    rowFailuresTruncated: "Amósanse os primeiros {{shown}} de {{count}} erros de fila. Resolve a causa común e téntao de novo para ver os erros restantes.",
                    success: "Todos os cambios do lado de Sequent aplicáronse correctamente.",
                },
                actions: {
                    cancel: "Cancelar",
                    back: "Atrás",
                    apply: "Aplicar",
                    next: "Seguinte",
                    startOver: "Comezar de novo",
                    close: "Pechar",
                },
                confirm: {
                    title: "Confirmar cambios de reconciliación",
                    categoriesNote: "As categorías resaltadas en laranxa ({{categories}}) afectan o estado de voto ou desactivan votantes.",
                    applyChanges: "Aplicar cambios",
                    continue: "Continuar",
                },
                summary: {
                    votedOtherChannel: "marca {{count}} votante(s) como votado(s) por outra canle",
                    disabled: "desactiva {{count}} votante(s)",
                    reenabled: "reactiva {{count}} votante(s)",
                    votedUnmarked: "desmarca {{count}} votante(s) como votante",
                    profileUpdated: "actualiza {{count}} perfil(s)",
                    voterAdded: "engade {{count}} votante(s)",
                    prefix: "Isto aplicará cambios que {{parts}}.",
                    empty: "Non hai cambios do lado de Sequent para aplicar.",
                },
                notifications: {
                    envelopeLoadError: "Non se puido cargar o diff de reconciliación - téntao de novo.",
                    generateFailed: "Non se puido calcular o diff de reconciliación - consulta o widget de tarefas para máis detalles.",
                    applyFailed: "Non se puideron aplicar os cambios do lado de Sequent - consulta o widget de tarefas para máis detalles.",
                    uploadUrlError: "Non se puido obter unha URL de subida",
                    generateTaskError: "Non se puido iniciar a tarefa de diff de reconciliación",
                    uploadError: "Non se puido subir o ficheiro de reconciliación",
                    applyTaskError: "Non se puido iniciar a tarefa de aplicación",
                    applyError: "Non se puideron aplicar os cambios de reconciliación",
                },
            },
        },
        logsScreen: {
            noPermissions: "Non tes permiso para acceder aos rexistros.",
            title: "Rexistros",
            subtitle: "Rexistros xerais das bases de datos principal e IAM",
            actions: {
                csv: "Exportar en CSV",
                pdf: "Exportar en PDF",
            },
            exportdialog: {
                description: "Confirme que quere executar esta acción; pode levar un tempo executarse.",
            },
            column: {
                id: "ID",
                statement_kind: "Tipo de declaración",
                created: "Creado",
                statement_timestamp: "Marca de tiempo de declaración",
                message: "Mensaje",
                user_id: "ID de usuario",
                username: "Nombre de Usuario",
                sender_pk: "Clave primaria del remitente",
                log_type: "Tipo de registro",
                event_type: "Tipo de evento",
                description: "Descripción",
                version: "Versión",
            },
            main: {
                title: "Rexistros da Base de Datos Principal",
            },
            iam: {
                title: "Rexistros da Base de Datos IAM",
            },
        },
        tasksScreen: {
            noPermissions: "Non tes permiso para acceder ás tarefas.",
            title: "Execución de Tarefas",
            subtitle: "Información sobre as tarefas executadas",
            taskInformation: "Información da Tarefa",
            status: "estado: {{status}}",
            ok: "Aceptar",
            column: {
                id: "Índice",
                name: "Nome da tarefa",
                type: "Tipo",
                execution_status: "Estado",
                start_at: "Hora de inicio",
                end_at: "Hora de fin",
                executed_by_user: "Executado por",
                annotations: "Anotacións",
                labels: "Etiquetas",
                logs: "Rexistros",
            },
            tasksExecution: {
                PUBLISH_BALLOT: "Publicar papeleta",
                VOTER_INFORMATION_LETTER: "Carta de información para o votante",
                EXPORT_ELECTION_EVENT: "Exportar evento electoral",
                CREATE_ELECTION_EVENT: "Crear Evento Electoral",
                IMPORT_ELECTION_EVENT: "Importar evento electoral",
                IMPORT_USERS: "Importar usuarios",
                EDIT_USER: "Editar votante",
                IMPORT_CANDIDATES: "Importar candidatos",
                EXPORT_VOTERS: "Exportar votantes",
                CREATE_TRANSMISSION_PACKAGE: "Crear paquete de transmisión",
                EXPORT_BALLOT_PUBLICATION: "Exportar Publicación de Boleta",
                EXPORT_ACTIVITY_LOGS_REPORT: "Exportar Informe de Registros de Actividad",
                GENERATE_REPORT: "Generar Reporte",
                GENERATE_TRANSMISSION_REPORT: "Generar Informe de Transmisión",
                EXPORT_TRUSTEES: "Exportar Autoridades",
                EXPORT_APPLICATION: "Exportar Solicitudes",
                EXPORT_TENANT_CONFIG: "Exportar Configuración del Cliente",
                IMPORT_TENANT_CONFIG: "Importar Configuración del Cliente",
                RENDER_DOCUMENT_PDF: "Renderizar el documento PDF",
                CREATE_TENANT: "Crear Cliente",
                EXPORT_TEMPLATES: "Exportar Plantillas",
                IMPORT_TEMPLATES: "Importar Plantillas",
                DELETE_ELECTION_EVENT: "Eliminar evento electoral",
                DELETE_VOTERS: "Delete Voters",
                PREPARE_PUBLICATION_PREVIEW: "Preparar a vista previa da publicación",
                EXPORT_TALLY_RESULTS_XLSX: "Exportar os resultados do reconto en formato XLSX",
                EXPORT_CERTIFICATE_AUTHORITIES: "Exportar autoridades de certificación",
                PUBLISH_RESULTS_WEBSITE: "Publicar sitio web de resultados",
            },
            documentAccess: {
                title: "Acceso ao documento",
                sensitivityNotice: "Información sensible. Comparta este contrasinal só co destinatario previsto.",
                passwordLabel: "Contrasinal para abrir o PDF cifrado",
                showPassword: "Amosar o contrasinal",
                copyPassword: "Copiar o contrasinal",
                passwordCopied: "Contrasinal copiado",
                passwordError: "Non se puido recuperar o contrasinal do PDF",
                copyError: "Non se puido copiar o contrasinal",
                guidance: "O contrasinal só se carga despois de escoller Amosar o contrasinal. Unha vez cargado, aparecerá aquí un campo de só lectura coa opción de copiar.",
            },
            widget: {
                taskTitle: "Tarefa: {{title}}",
                viewTask: "Ver Tarefa",
                downloadDocument: "Descargar Archivo",
            },
            exportTasksExecution: {
                success: "Exportación finalizada con éxito",
                error: "Erro ao exportar a Execución de Tarefas",
            },
        },
        areas: {
            common: {
                title: "Áreas",
                subTitle: "Configuración de áreas.",
                deleteError: "Erro ao eliminar a área",
            },
            createAreaSuccess: "Área creada",
            updateAreaSuccess: "Área actualizada",
            createAreaError: "Non se puido crear a área",
            sequent_backend_area_contest: "Concursos",
            empty: {
                header: "Aínda non hai áreas.",
                action: "Crear Área",
            },
            formImputs: {
                allowEarlyVoting: "Permitir Votación Anticipada",
            },
        },
        integrationsScreen: {
            common: {
                gapiKey: "Clave de Conta de Servizo de Google Calendar",
                gapiEmail: "Correo de Autenticación de Google Calendar",
            },
            errors: {
                invalidGapiKey: "Formato de Clave de Conta de Servizo de Google Calendar inválido",
            },
        },
        lookAndFeelScreen: {
            common: {
                helpLinks: "Ligazóns de Axuda",
                logoUrl: "URL do Logo",
                css: "CSS Personalizado",
            },
            errors: {
                invalidHelpLinks: "Formato de Ligazóns de Axuda inválido",
            },
        },
        electionTypeScreen: {
            noPermissions: "Non tes permiso para acceder ás configuracións.",
            common: {
                title: "Tipo de Elección",
                subtitle: "Configuración do tipo de elección",
                onlineVoting: "Votación en Liña",
                kioskVoting: "Votación en Quiosco",
                telephoneVoting: "Votación Telefónica",
                settingTitle: "Configuracións",
                settingSubtitle: "Configuración Xeral",
                sms: "SMS",
                mail: "Correos",
                createNew: "Crear Tipo de Elección",
                emptyHeader: "Aínda non hai Tipos de Elección.",
                emptyBody: "¿Queres crear un?",
            },
            create: {
                title: "Crear Tipo de Elección",
            },
            edit: {
                title: "Editar Tipo de Elección",
            },
            tabs: {
                votingChannels: "CANLES DE VOTACIÓN",
                electionTypes: "TIPOS DE ELECCIÓN",
                templates: "MODELOS",
                languages: "IDIOMAS",
                localization: "LOCALIZACIÓN",
                integrations: "Integracións",
                lookAndFeel: "Aspecto",
                schedules: "EVENTOS PROGRAMADOS",
                trustees: "FIDUCIARIOS",
                BackupRestore: "COPIA DE SEGURIDAD / RESTAURAR",
            },
        },
        trusteesSettingsScreen: {
            common: {
                emptyHeader: "Aún no hay fideicomisarios.",
                createNew: "Crear fideicomisario",
                title: "Fideicomisario",
                subtitle: "Configuración del fideicomisario",
                emptyBody: "¿Quieres crear uno?",
            },
            create: {
                title: "Crear fideicomisario",
            },
            edit: {
                title: "Editar fideicomisario",
            },
        },
        scheduleScreen: {
            noPermissions: "Non tes permiso para acceder ás configuracións.",
            createScheduleSuccess: "Programación creada",
            createScheduleError: "Erro ao crear a programación",
            deleteScheduleSuccess: "Programación eliminada",
            deleteScheduleError: "Erro ao eliminar a programación",
            common: {
                title: "Programación",
                subtitle: "Configuración de programacións",
                createNew: "Crear Programación",
                emptyHeader: "Aínda non hai Programacións.",
                emptyBody: "¿Queres crear unha?",
            },
            create: {
                title: "Crear Programación",
                selectSchedule: "Seleccione unha programación da lista predefinida ou escriba unha personalizada",
            },
            edit: {
                title: "Editar Programación",
            },
            eventTypes: {
                SYSTEM_LOCKDOWN_FOR_INTERNET_VOTING_SETTINGS: "Bloqueo do sistema para a finalización das configuracións de votación por Internet",
                START_PRE_REGISTRATION_OVCS: "Inicio e fin da preinscrición para OVCS",
                END_PRE_REGISTRATION_OVCS: "Fin da preinscrición para OVCS",
                START_TEST_VOTING_PERIOD: "Inicio do período de votación de proba",
                END_TEST_VOTING_PERIOD: "Fin do período de votación de proba",
                START_INTERNET_VOTING_PERIOD: "Inicio do período de votación por Internet",
                END_INTERNET_VOTING_PERIOD: "Fin do período de votación por Internet",
                LAB_TEST: "Proba de Laboratorio",
                FIELD_TEST: "Proba de Campo",
                MOCK_ELECTIONS: "Eleccións Simuladas",
                FTS: "FTS",
            },
        },
        dashboard: {
            voteByDay: "Votos por día",
            votesOverTime: "Votos ao longo do tempo",
            timeResolution: "Resolución temporal",
            timeRange: "Intervalo de tempo",
            minute: "Minuto",
            hour: "Hora",
            day: "Día",
            votersByChannels: "Votantes por canle",
            voterLoginURL: "URL de Inicio de Sesión do Votante",
            voterEnrollURL: "URL de Rexistro do Votante",
            voterEnrollKioskURL: "Kiosk URL de inscripción de votantes",
            ipAddress: {
                emptyState: "Aínda non hai votos.",
                title: "Enderezos IP",
                ip: "IP",
                country: "País",
                VoteCount: "Contaxe de Votos",
                ElectionName: "Nome da Elección",
                VotersId: "ID dos Votantes",
            },
        },
        electionEventScreen: {
            common: {
                subtitle: "Configuración do evento electoral.",
                showMore: "Mostrar Máis",
                showLess: "Mostrar Menos",
                adminPortal: "Portal de Administración",
                allowPublishAfterLockdown: "Só permitir a publicación do evento electoral despois do bloqueo",
                reset: "Restablecer filtro personalizado",
            },
            edit: {
                general: "Xeral",
                dates: "Datas",
                customUrls: "Prefixo de URLs Personalizados",
                votingPeriod: "Período de Votación",
                language: "Idioma",
                allowed: "Canles de Votación Permitidas",
                materials: "Materiais de Soporte",
                ballotDesign: "Deseño da Papeleta",
                templates: "Modelos",
                reorder: "Reordenar eleccións",
                advancedConfigurations: "Configuracións Avanzadas",
                importCandidates: "Importar Candidatos",
                custom_filters: "Filtros Personalizados",
                voter_authentication: "Autenticación de votantes",
                realm_attributes: "Keycloak realm attributes",
                realm_attributes_load_error: "Error loading Keycloak realm attributes",
                realm_attributes_update_error: "Error updating Keycloak realm attributes",
                realm_attributes_not_loaded: "Keycloak realm attributes have not loaded, changes were not saved",
                password_policy: "Password Policy",
                password_policy_load_error: "Error loading Keycloak password policy",
                password_policy_update_error: "Error updating Keycloak password policy",
                password_policy_not_loaded: "Keycloak password policy has not loaded, changes were not saved",
            },
            customUrls: {
                login: "Iniciar Sesión",
                enrollment: "Rexistro",
            },
            localization: {
                emptyHeader: "Non se estableceron idiomas para o evento",
                selectLanguage: "Seleccionar Idioma",
                notify: {
                    success: "Localización actualizada correctamente",
                    error: "Fallou a actualización da localización",
                    duplicateKey: "Xa existe unha substitución con esta clave e ámbito do portal.",
                    invalidDateTimeFormat: "Formato de data/hora non válido. Usa os tokens yyyy, MM, dd, HH, mm, ss (p. ex. dd/MM/yyyy HH:mm).",
                },
                common: {
                    title: "Localización",
                    subTitle: "Configuración de localización",
                },
                labels: {
                    key: "Clave",
                    scope: "Ámbito do portal",
                    value: "Valor",
                },
                scopes: {
                    legacy: "Herdado ({{portal}})",
                    global: "Global",
                    votingPortal: "Portal de votación",
                    ballotVerifier: "Verificador de papeletas",
                    resultsPortal: "Portal de resultados",
                    adminPortal: "Portal de administración",
                },
            },
            field: {
                passwordPolicy: {
                    minimumLength: "Lonxitude mínima",
                    maximumLength: "Lonxitude máxima",
                    includeUppercase: "Incluír letras maiúsculas",
                    includeLowercase: "Incluír letras minúsculas",
                    includeDigits: "Incluír díxitos",
                    includeSpecialCharacters: "Incluír caracteres especiais",
                    help: {
                        minimumLength: "O número mínimo de caracteres requiridos para o contrasinal.",
                        maximumLength: "O número máximo de caracteres permitidos para o contrasinal.",
                        includeUppercase: "O contrasinal debe incluír polo menos unha letra maiúscula.",
                        includeLowercase: "O contrasinal debe incluír polo menos unha letra minúscula.",
                        includeDigits: "O contrasinal debe incluír polo menos un díxito.",
                        includeSpecialCharacters: "O contrasinal debe incluír polo menos un carácter especial.",
                    },
                    notConfigured: "Non hai ningunha política de contrasinais configurada. Ao gardar aplicaranse os valores predeterminados que se mostran a continuación.",
                    errors: {
                        lengthRange: "As lonxitudes do contrasinal deben ser números enteiros entre 1 e 256.",
                        minimumExceedsMaximum: "A lonxitude mínima non pode superar a lonxitude máxima.",
                        characterClassRequired: "Seleccione polo menos unha clase de caracteres para o contrasinal.",
                    },
                },
                name: "Nome",
                alias: "Alias",
                description: "Descrición",
                startDateTime: "Data e Hora de Inicio",
                endDateTime: "Data e Hora de Fin",
                language: "Idioma",
                votingChannels: "Canles de Votación",
                materialActivated: "Materiais de Soporte Activados",
                supportMaterialsPolicy: {
                    label: "Política de Materiais de Soporte",
                    helperText: "A opción Obrigatorio para Votar require que os votantes abran cada Material de Soporte e confirmen que o leron antes de poder votar.",
                    options: {
                        off: "Desactivado",
                        optional: "Opcional",
                        mandatory_for_voting: "Obrigatorio para Votar",
                    },
                },
                materialTitle: "Título",
                materialSubTitle: "Subtítulo",
                logoUrl: "URL do Logo",
                userVerification: "Pode introducir un modelo personalizado que se utilizará para verificar manualmente os votantes",
                redirectFinishUrl: "URL de Redirección ao Finalizar",
                kioskRedirectFinishUrl: "URL de Redirección ao Finalizar do Quiosco",
                css: "CSS Personalizado",
                skipElectionList: "Omitir Pantalla de Lista de Eleccións",
                showUserProfile: "Mostrar Perfil do Usuario",
                showCastVoteLogs: {
                    policyLabel: "Mostrar Tab de Logs de Votación",
                    options: {
                        "show-logs-tab": "Mostrar Tab de Logs de Votación",
                        "hide-logs-tab": "No Mostrar Tab de Logs de Votación",
                    },
                },
                lockdownState: {
                    policyLabel: "Estado de Bloqueo",
                    options: {
                        "locked-down": "Bloqueado",
                        "not-locked-down": "Non Bloqueado",
                    },
                },
                decodedBallots: {
                    policyLabel: "Incluír papeletas descodificadas na base de datos de resultados",
                    options: { "included": "Incluír", "not-included": "Non incluír" },
                },
                contestEncryptionPolicy: {
                    options: {
                        "single-contest": "Concurso único",
                        "multiple-contests": "Varios concursos",
                    },
                    policyLabel: "Política de cifrado de concurso",
                },
                votingPortalDateTimeFormat: {
                    policyLabel: "Formato de data e hora do portal de votación",
                    helperText: 'Aplícase a todo o evento. Para substituílo por idioma, engade a clave "votingPortalDateTimeFormat" na pestana Localización usando os tokens yyyy, MM, dd, HH, mm, ss (p. ex. dd/MM/yyyy HH:mm). Consulta a documentación para máis detalles.',
                    options: {
                        "legacy-gb-24h": "Legacy GB 24h (dd/MM/yyyy HH:mm, 24h)",
                        "iso-local": "ISO Local (yyyy-MM-dd HH:mm)",
                        "us-12h": "US 12h (MM/dd/yyyy h:mm AM/PM)",
                        "locale-medium": "Locale Medium (data media, hora curta)",
                        "date-only": "Date Only (sen hora)",
                        "custom": "Formato personalizado",
                    },
                    customFormat: {
                        label: "Formato de data e hora personalizado",
                        helperText: "Usa os tokens yyyy, MM, dd, HH, mm, ss (p. ex. dd/MM/yyyy HH:mm). Calquera outro carácter móstrase literalmente.",
                        invalid: "Formato non válido. Usa polo menos un dos tokens yyyy, MM, dd, HH, mm, ss.",
                    },
                },
                countDownPolicyOptions: {
                    NO_COUNTDOWN: "Sen Conta Atrás",
                    COUNTDOWN: "Conta Atrás",
                    COUNTDOWN_WITH_ALERT: "Conta Atrás con Alerta",
                    sectionTitle: "Portal de Votación",
                    policyLabel: "Política de Conta Atrás do Portal de Votación",
                    coundownSecondsLabel: "tempo en segundos antes da expiración para mostrar a conta atrás",
                    alertSecondsLabel: "tempo en segundos antes da expiración para mostrar a alerta de peche de sesión",
                },
                voterSigningPolicy: {
                    "policyLabel": "Política de Firma de Votantes",
                    "no-signature": "Sin firma",
                    "with-signature": "Con firma",
                },
                VoterCertificatePolicy: {
                    policyLabel: "Voter Digital Certificate Policy",
                    enabled: "Habilitado",
                    disabled: "Deshabilitado",
                },
                enrollment: {
                    policyLabel: "Inscripción",
                    options: {
                        enabled: "Habilitado",
                        disabled: "Deshabilitado",
                    },
                },
                otp: {
                    policyLabel: "OTP",
                    options: {
                        enabled: "Habilitado",
                        disabled: "Deshabilitado",
                    },
                },
                ceremoniesPolicy: {
                    policyLabel: "Política de cerimonias de chaves/reconto",
                    options: {
                        "automated-ceremonies": "Permitir cerimonias automáticas",
                        "manual-ceremonies": "Cerimonias manuais",
                    },
                },
                automaticRecountPolicy: {
                    policyLabel: "Reconto automático tras aprobar unha importación",
                    options: {
                        enabled: "Activado",
                        disabled: "Desactivado",
                    },
                },
                weightedVotingPolicy: {
                    policyLabel: "Política de Votación Ponderada",
                    options: {
                        "areas-weighted-voting": "Votación Ponderada por Áreas",
                        "voters-weighted-voting": "Votación Ponderada por Votantes",
                        "disabled-weighted-voting": "Votación Ponderada Desactivada",
                    },
                    noDelegated: "A Votación Ponderada por Votantes non pode combinarse co Voto Delegado",
                    noDecodedBallots: "A Votación Ponderada por Votantes non pode combinarse coa inclusión de papeletas descifradas nos resultados",
                },
                delegatedVotingPolicy: {
                    policyLabel: "Política de Voto Delegado",
                    options: {
                        enabled: "Activado",
                        disabled: "Desactivado",
                    },
                },
                languageDetectionPolicy: {
                    policyLabel: "Política de detección de idioma",
                    options: {
                        "browser-detect": "Detectar desde o navegador",
                        "force-default": "Forzar predeterminado",
                    },
                },
            },
            error: {
                endDate: "A data de fin debe ser posterior á data de inicio",
                startDate: "A data de inicio debe ser no futuro",
                noResult: "Aínda non hai Evento Electoral",
                endDateInvalid: "A data de fin debe ser no futuro",
            },
            voters: {
                title: "Votantes",
            },
            createElectionEventSuccess: "Evento Electoral creado",
            createElectionEventError: "Erro ao crear o evento electoral",
            ivr: {
                tabs: {
                    config: "Configuración",
                    blacklist: "Lista de bloqueo",
                    prompts: "Locucións",
                    emulator: "Emulador",
                },
                common: {
                    saveSuccess: "Gardado correctamente",
                    saveError: "Non se puido gardar",
                    deleteSuccess: "Eliminado correctamente",
                    deleteError: "Non se puido eliminar",
                },
                config: {
                    configuredPhone: "Número de teléfono configurado",
                    infoMsg: "Configure o fluxo do IVR e as súas propiedades a continuación. Para máis detalles, póñase en contacto con Sequent.",
                },
                prompts: {
                    emptyMsg: "Aínda non se creou ningunha mensaxe",
                    infoMsg: "Configure as mensaxes utilizadas polo IVR. As mensaxes de anuncio son obrigatorias, e as mensaxes do sistema pódense sobrescribir para os idiomas desexados. Admítese SSML, tamén para mesturar idiomas.",
                    editorTitle: "Mensaxe",
                    editorSubtitle: "Configuración da mensaxe",
                },
                blacklist: {
                    columns: {
                        phone: "Número de teléfono",
                        reason: "Motivo",
                        createdAt: "Creado o",
                        createdBy: "Creado por",
                        createdBefore: "Creado antes",
                        createdAfter: "Creado despois",
                    },
                    emptyMsg: "Non hai entradas na lista de bloqueo",
                    infoMsg: "Configure a lista de bloqueo do IVR. As chamadas destes números serán desconectadas automaticamente polo sistema.",
                    noFilterMatch: "Ningunha entrada coincide cos filtros indicados",
                    phoneRequired: "O número de teléfono é obrigatorio",
                },
                emulator: {
                    infoMsg: "Seleccione unha área e as eleccións desexadas para probar a sesión IVR.",
                    apiStatus: {
                        unavailable: "O sistema do emulador non está dispoñible na súa contorna",
                        loading: "Cargando o sistema do emulador",
                        error: "Erro ao cargar o sistema do emulador",
                    },
                    hints: {
                        title: "Suxestións",
                        publishRequired: "Calquera cambio realizado nas eleccións, nas contendas ou nos candidatos debe publicarse primeiro para que estea dispoñible. No emulador só se utilizarán os estilos de papeleta publicados máis recentemente para a área correspondente.",
                        eventChangesImmediate: "Os cambios realizados no evento electoral, como a configuración IVR ou as modificacións das mensaxes, están dispoñibles inmediatamente ao reiniciar a sesión do emulador.",
                        credentials: 'O identificador de votante e o PIN válidos son "123" e "123".',
                    },
                    sendDtmf: "Enviar entrada DTMF",
                    sendTimeout: "Enviar tempo de espera",
                    disconnected: "Desconectado",
                    startSession: "Iniciar unha nova sesión",
                    endSession: "Finalizar a sesión",
                    noStylesFound: "Non se atoparon estilos de papeleta publicados que coincidan coas súas seleccións",
                    inputPlaceholder: "Introduza a súa entrada (máximo de díxitos={{maxDigits}}, entradas válidas={{validInputs}}, tempo de espera={{timeout}} s)",
                    blacklistCaller: "Bloquear a persoa que chama",
                    elections: "Eleccións",
                    area: "Área",
                },
            },
            stats: {
                elegibleVoters: "Votantes Elixibles",
                voters: "Votantes Actuais",
                elections: "Eleccións",
                contests: "Concursos",
                areas: "Áreas",
                sentEmails: "Correos enviados",
                sentSMS: "SMS enviados",
                calendar: {
                    title: "Calendario",
                    scheduled: "Programado",
                },
            },
            keys: {
                createNew: "Crear Cerimonia de Chaves",
                emptyHeader: "Aínda non hai Cerimonia de Chaves.",
                statusLabel: "Estado",
                waitingKeys: "Esperando a Xeración de Chaves...",
                started: "Iniciado o",
                breadCrumbs: {
                    configure: "Configurar",
                    ceremony: "Cerimonia",
                    created: "Finalizado",
                    start: "Inicio",
                    status: "Estado",
                    download: "Descargar",
                    check: "Verificar",
                    success: "Finalizado",
                },
                notify: {
                    participateNow: "Fostes invitado a participar nunha Cerimonia de Chaves. Por favor, <1>fai clic na Acción de Chave da cerimonia</1> para participar.",
                },
            },
            tabs: {
                dashboard: "Taboleiro",
                monitoring: "Monitoreo",
                data: "Datos",
                ivr: "IVR",
                localization: "Localización",
                voters: "Votantes",
                areas: "Áreas",
                keys: "Chaves",
                tally: "Escrutinio",
                tallySheetImports: "Importación de actas",
                publish: "Publicar",
                logs: "Rexistros",
                tasks: "Tarefas",
                events: "Eventos Programados",
                notifications: "Notificacións",
                reports: "Informes",
                approvals: "Aprobacións",
                cas: "Certificados",
            },
            tally: {
                emptyHeader: "Aínda non hai Escrutinio.",
                title: "Escrutinio do Evento Electoral",
                elections: "Eleccións",
                electionNumber: "Número de Eleccións",
                trustees: "Fiduciarios",
                status: "Estado",
                permissionLabels: "Etiquetas de Permisos",
                tallyType: {
                    label: "Tipo de Conteo",
                    ELECTORAL_RESULTS: "Resultados Electorales",
                    INITIALIZATION_REPORT: "Resultados de Inicialización",
                },
                create: {
                    title: "Crear Escrutinio",
                    subtitle: "Crear un novo Escrutinio para este Evento Electoral",
                    createTallyButton: "Iniciar Cerimonia de Escrutinio",
                    createInitializationReportButton: "Xerar Informe de Inicialización",
                    error: {
                        create: "Erro ao crear o Escrutinio",
                    },
                    success: "Escrutinio creado",
                },
                logs: {
                    noLogs: "Non hai rexistros dispoñibles",
                },
                notify: {
                    noKeysTally: "A Cerimonia de Escrutinio non pode comezar ata que a Cerimonia de Chaves se complete con éxito.",
                    noPublication: "A Cerimonia de Escrutinio non pode comezar ata que crees unha publicación na pestana Publicar.",
                    participateNow: "Fostes invitado a participar nunha Cerimonia de Escrutinio. Por favor, <1>fai clic na Acción de Chave da cerimonia</1> para participar.",
                    startDisabled: "No puedes continuar con la ceremonia porque no se han seleccionado elecciones o las elecciones no están publicadas.",
                    ceremonyDisabled: "No puedes continuar con la ceremonia porque la sesión de recuento no está conectada o el inicio de la ceremonia no está permitido.",
                },
            },
            importAreas: {
                title: "Importar Áreas",
                subtitle: "Importar datos de áreas",
                areaParagraph: "Importar áreas usando un ficheiro de folla de cálculo en formato CSV (Comma Separated Values).",
                importSuccess: "Áreas importadas correctamente",
                importError: "Erro ao importar as Áreas",
                upsert: "Actualizar ou Inserir Áreas",
            },
            import: {
                eetitle: "Importar Evento Electoral",
                eesubtitle: "Importar datos do evento electoral",
                title: "Importar Votantes",
                subtitle: "Importar datos de votantes",
                voters: "Votantes",
                votersParagraph: "Importar votantes usando un ficheiro de folla de cálculo en formato CSV (Comma Separated Values). Descarga un exemplo de ficheiro CSV de importación aquí.",
                electionEventParagraph: "Importar Eventos Electorais usando un ficheiro JSON.",
                elections: "Eleccións",
                areas: "Áreas",
                sha: "Verificación de Integridade (SHA-256)",
                cancel: "Cancelar",
                import: "Importar",
                fileUploadSuccess: "Ficheiro cargado no servidor - pero aínda non importado",
                fileUploadError: "Erro ao cargar o ficheiro",
                importVotersSuccess: "Importación de Votantes Programada Correctamente",
                importVotersError: "Erro ao importar os Votantes",
                importElectionEventSuccess: "Election event imported Successfully",
                importElectionEventError: "Error importing election event",
                shaDialog: {
                    ok: "Si, Importar sen Verificación de Integridade",
                    cancel: "Volver Atrás",
                    title: "¿Importar Sen Verificación de Integridade?",
                    description: "Non introduciu o campo de Verificación de Integridade (SHA-256). Por favor, confirme que está a importar o ficheiro correcto e que desexa importalo.",
                },
                passwordDialog: {
                    title: "Contrasinal de Descrifrado",
                    description: "Introduza o contrasinal para descifrar o ficheiro",
                    label: "Contrasinal",
                    copyPassword: "Copiar Contrasinal",
                    ok: "Aceptar",
                },
            },
            export: {
                title: "Exportar Evento Electoral",
                subtitle: "A exportación pode ser unha operación longa. ¿Estás seguro de que queres exportar os rexistros?",
                encryptWithPassword: "Cifrar con Contrasinal",
                passwordForcedNote: "O arquivo protexerase con contrasinal de todos os xeitos: os informes, as solicitudes e os datos do taboleiro cífranse sempre. Marca a caixa para incluír tamén os campos secretos de votante descifrados.",
                includeVoters: "Incluir Votantes",
                activityLogs: "Rexistros de Actividade",
                bulletinBoard: "Taboleiro de Anuncios",
                publications: "Publicacións",
                s3Files: "Ficheiros S3",
                scheduledEvents: "Eventos Programados",
                exportSuccess: "Evento Electoral exportado correctamente",
                exportError: "Erro ao exportar o Evento Electoral",
                passwordTitle: "Contrasinal",
                passwordDescription: "Contrasinal para descifrar o ficheiro:",
                copiedSuccess: "Contrasinal copiado ao portapapeis",
                copiedError: "Erro ao copiar o contrasinal",
                reports: "Informes",
                applications: "Aplicaciones",
                tally: "Recuento",
                certificates: "Certificados",
            },
            taskNotification: "{{action}} comezou. Podes ver o seu estado na táboa de Execución de Tarefas.",
        },
        electionScreen: {
            common: {
                title: "Elección",
                subtitle: "Configuración da elección.",
                fileLoaded: "Ficheiro cargado",
                noPermission: "Non tes permiso para acceder a esta elección.",
            },
            edit: {
                general: "Xeral",
                dates: "Datas",
                votingPeriod: "Período de Votación",
                language: "Idioma",
                allowed: "Canles de Votación Permitidas",
                default: "Predeterminado",
                defaultLang: "Idioma Predeterminado",
                receipts: "Recibos",
                image: "Imaxe",
                advanced: "Configuración Avanzada",
                numAllowedVotes: "Número de votos permitidos",
                reorder: "Reordenar concursos",
                castVoteConfirm: "Modal de Confirmación de Voto Emitido",
                gracePeriodPolicy: "Período de Gracia",
                allowTallyPolicy: "Permitir Recuento",
                permissionLabel: "Etiqueta de Permiso",
                custom_filters: "Filtros Personalizados",
            },
            field: {
                name: "Nome",
                language: "Idioma",
                votingChannels: "Canles de Votación",
                startDateTime: "Data e Hora de Inicio",
                endDateTime: "Data e Hora de Fin",
                startDateTimeWithTimezone: "Data e Hora de Inicio ({{timezone}})",
                endDateTimeWithTimezone: "Data e Hora de Fin ({{timezone}})",
                scheduledOpening: "Apertura Programada",
                scheduledClosing: "Peche Programado",
                alias: "Alias",
                description: "Descrición",
                securityConfirmationHtml: "Confirmación de seguridade HTML",
                ivrPrompt: "Mensaxe IVR",
                externalId: "ID externo",
            },
            securityConfirmationPolicy: {
                label: "Política da caixa de confirmación de seguridade",
                none: "Ningún",
                mandatory: "Obrigatorio",
            },
            error: {
                fileError: "Erro ao cargar o ficheiro",
                fileLoaded: "Ficheiro cargado",
                endDate: "A data de fin debe ser posterior á data de inicio",
                startDate: "A data de inicio debe ser no futuro",
                endDateInvalid: "A data de fin debe ser no futuro",
            },
            createElectionEventSuccess: "Evento Electoral creado",
            createElectionEventError: "Erro ao crear o evento electoral",
            tabs: {
                dashboard: "Taboleiro",
                monitoring: "Monitoreo",
                data: "Datos",
                voters: "Votantes",
                publish: "Publicar",
                logs: "Rexistros",
                approvals: "Aprobacións",
                tallySheets: "Follas de recuento",
            },
            gracePeriodPolicy: {
                "label": "Política de Período de Gracia",
                "no-grace-period": "Sen período de gracia",
                "grace-period-without-alert": "Período de gracia sen alerta",
                "gracePeriodSecs": "Período de gracia en segundos",
            },
            allowTallyPolicy: {
                "allowed": "Permitido",
                "disallowed": "No permitido",
                "requires-voting-period-end": "Permitir cuando termine el periodo de votación",
            },
            initializeReportPolicy: {
                "label": "Política de Informe de Inicialización",
                "not-required": "Non Requirido",
                "required": "Requirido",
            },
            castVoteGoldLevelPolicy: {
                label: "Gold level Authentication Policy",
                options: {
                    "gold-level": "Gold level Authentication",
                    "no-gold-level": "No Gold level Authentication",
                },
            },
            startScreenTitlePolicy: {
                label: "Política de título da pantalla de inicio",
                options: {
                    "election": "Título da elección",
                    "election-event": "Título do evento electoral",
                },
            },
            consolidatedReportPolicy: {
                label: "Política de informe consolidado",
                options: {
                    "generate": "Xerar",
                    "do-not-generate": "Non xerar",
                },
            },
            declineToVotePolicy: {
                label: "Política de abstención de voto",
                options: {
                    enabled: "Activado",
                    disabled: "Desactivado",
                },
            },
            blankBallotsPolicy: {
                label: "Política de papeletas en branco",
                options: {
                    enabled: "Activado",
                    disabled: "Desactivado",
                },
            },
            votingScreenBackPolicy: {
                label: "Política do botón Atrás da pantalla de votación",
                options: {
                    "election-selection-screen": "Ir á pantalla de selección de eleccións",
                    "start-screen": "Ir á pantalla de inicio da elección",
                },
            },
        },
        tenantScreen: {
            common: {
                title: "Arrendatarios",
            },
            new: {
                subtitle: "Crear novo arrendatario",
            },
            createSuccess: "Arrendatario creado",
            createError: "Erro ao crear o arrendatario",
        },
        usersAndRolesScreen: {
            noPermissions: "Non tes permiso para acceder a usuarios ou roles.",
            common: {
                title: "Usuarios e Roles",
                subtitle: "Configuración xeral",
                mobileNumber: "Móbil",
            },
            editPassword: {
                passwordPolicyViolation: "O contrasinal non cumpre a Política de contrasinais deste evento electoral. Revise a política en Datos do evento electoral e introduza un contrasinal válido.",
                passwordPolicyRules: {
                    minimumLength: "A lonxitude mínima do contrasinal é {{count}}.",
                    maximumLength: "A lonxitude máxima do contrasinal é {{count}}.",
                    uppercase: "Caracteres en maiúscula requiridos: {{count}}.",
                    lowercase: "Caracteres en minúscula requiridos: {{count}}.",
                    digits: "Díxitos requiridos: {{count}}.",
                    specialCharacters: "Caracteres especiais requiridos: {{count}}.",
                },
                label: "Cambiar contrasinal",
                temporatyLabel: "Temporal",
                temporatyInfo: "Se está habilitado, o usuario debe cambiar o contrasinal no próximo inicio de sesión",
            },
            users: {
                title: "Usuarios",
                subtitle: "Ver e editar datos de usuarios",
                review: {
                    title: "Revisar cambios",
                    subtitle: "Confirma estas actualizacións antes de envialas.",
                    confirm: "Confirmar cambios",
                    noChanges: "Non hai cambios para revisar",
                    field: "Campo",
                    currentValue: "Valor actual",
                    newValue: "Novo valor",
                },
                edit: {
                    title: "Datos do Usuario",
                    subtitle: "Ver e editar usuario",
                },
                create: {
                    title: "Usuario",
                    subtitle: "Crear usuario",
                },
                fields: {
                    "has_voted": "Votou",
                    "support_materials_viewed": "Support Materials Viewed",
                    "vote-weight": "Peso do voto",
                    "voted-channel": "Canle de voto",
                    "disable-comment": "Comentario de desactivación",
                    "username": "Nome de Usuario",
                    "first_name": "Nome",
                    "last_name": "Apelidos",
                    "email": "Correo Electrónico",
                    "enabled": "Activado",
                    "emailVerified": "Correo Verificado",
                    "groups": "Grupos",
                    "attributes": "Atributos",
                    "area": "Área",
                    "password": "Contrasinal",
                    "savePassword": "Guardar contraseña",
                    "repeatPassword": "Repetir Contrasinal",
                    "passwordMismatch": "Os contrasinais deben coincidir",
                    "passwordLengthValidate": "O contrasinal debe ter polo menos 8 caracteres",
                    "passwordUppercaseValidate": "O contrasinal debe conter polo menos unha letra maiúscula",
                    "passwordLowercaseValidate": "O contrasinal debe conter polo menos unha letra minúscula",
                    "passwordDigitValidate": "O contrasinal debe conter polo menos un díxito",
                    "passwordSpecialCharValidate": "O contrasinal debe conter polo menos un carácter especial",
                    "trustee": "Actuar como Fiduciario",
                    "permissionLabel": "Etiqueta de Permiso",
                    "authorized-election-ids": "Eleccións",
                },
                delete: {
                    body: "¿Estás seguro de que queres eliminar este usuario?",
                    bulkBody: "¿Estás seguro de que queres eliminar os usuarios seleccionados?",
                    bulkBodySelected: "Delete the {{count}} selected users? This cannot be undone.",
                    bulkBodyChoose: "{{count}} users are selected. You can instead delete every user matching the current filters, which may be more. This cannot be undone.",
                    okSelected: "Delete {{count}} selected",
                    okAllMatching: "Delete all matching",
                },
                notifications: {
                    exportError: "Erro ao exportar usuarios",
                    deleteError: "Erro ao eliminar o usuario",
                    deleteSuccess: "Usuario eliminado",
                    multipleDeleteSuccess: "Usuarios eliminados",
                },
            },
            voters: {
                voterInformationLetter: {
                    label: "Carta de información para o votante",
                    generate: "Xerar",
                    confirmation: "Xerar unha Carta de información para este votante? Asignarase un novo contrasinal e incluirase nun PDF cifrado.",
                    generationStarted: "Iniciouse a xeración da Carta de información",
                    generationError: "Non se puido xerar a Carta de información",
                    policyNotConfigured: "A Política de contrasinais non está configurada. Configúrea en Datos do evento electoral antes de xerar unha carta.",
                    policyMinimumLengthMissing: "A Política de contrasinais debe incluír unha lonxitude mínima antes de xerar unha carta.",
                    policyCharacterClassMissing: "A Política de contrasinais debe incluír polo menos unha clase de caracteres antes de xerar unha carta.",
                },
                title: "Votantes",
                subtitle: "Ver e editar datos de votantes",
                secretAttribute: {
                    storedPlaceholder: "Valor cifrado almacenado",
                    reveal: "Mostrar",
                    hide: "Ocultar",
                    revealError: "Non se puido mostrar o campo cifrado do votante",
                    includeInExport: "Incluír campos secretos descifrados do votante",
                    exportWarning: "Exportación sensible: o CSV descargado conterá estes campos en texto plano.",
                    clear: "Borrar",
                    add: "Engadir valor",
                    remove: "Eliminar valor",
                },
                review: {
                    title: "Revisar cambios",
                    subtitle: "Confirma estas actualizacións antes de envialas.",
                    confirm: "Confirmar cambios",
                    noChanges: "Non hai cambios para revisar",
                    field: "Campo",
                    currentValue: "Valor actual",
                    newValue: "Novo valor",
                },
                logs: {
                    label: "Rexistros do Usuario",
                },
                create: {
                    title: "Votante",
                    subtitle: "Crear Votante",
                },
                manualVerification: {
                    label: "Verificar Manualmente",
                    verify: "Verificar manualmente este votante",
                    body: "Verificar manualmente este votante. Obterás un PDF cunha ligazón de código QR que permite ao votante iniciar sesión omitindo o KYC en liña.",
                    noEmailOrPhone: "Este votante no puede ser verificado manualmente porque no tiene una dirección de correo electrónico o un número de teléfono asociado a él.",
                },
                emptyHeader: "Aínda non hai votantes.",
                askCreate: "¿Queres crear un?",
                errors: {
                    editError: "Erro ao editar o votante",
                    editErrorReason: "Erro ao editar o votante: {{reason}}",
                    editSuccess: "Votante editado",
                    createError: "Erro ao crear o votante",
                    createErrorReason: "Erro ao crear o votante: {{reason}}",
                    createSuccess: "Votante creado",
                    attribute: {
                        invalidNamed: 'Rexeitouse "{{field}}": {{constraint}}',
                        fieldsToCorrect: "Algúns campos deben corrixirse antes de gardar",
                        hintBetween: "Entre {{min}} e {{max}} caracteres",
                        hintMin: "Polo menos {{min}} caracteres",
                        hintMax: "Como máximo {{max}} caracteres",
                        andMore: "e {{count}} máis",
                        invalidLength: '"{{field}}" debe ter entre {{min}} e {{max}} caracteres',
                        tooShort: '"{{field}}" debe ter polo menos {{min}} caracteres',
                        tooLong: '"{{field}}" debe ter como máximo {{max}} caracteres',
                        required: '"{{field}}" é obrigatorio',
                        invalidEmail: '"{{field}}" debe ser un enderezo de correo electrónico válido',
                        invalidFormat: '"{{field}}" non ten o formato esperado',
                        invalid: '"{{field}}" ten un valor non válido',
                    },
                    createPasswordError: "Votante creado, pero non se puido establecer o seu contrasinal",
                    createPasswordErrorReason: "Votante creado, pero non se puido establecer o seu contrasinal: {{reason}}",
                },
                delete: {
                    body: "¿Estás seguro de que queres eliminar este votante?",
                    bulkBody: "¿Estás seguro de que queres eliminar os votantes seleccionados?",
                    bulkBodySelected: "Delete the {{count}} selected voters? This cannot be undone.",
                    bulkBodyChoose: "{{count}} voters are selected. You can instead delete every voter matching the current filters, which may be more. This cannot be undone.",
                    okSelected: "Delete {{count}} selected",
                    okAllMatching: "Delete all matching",
                },
                notifications: {
                    exportError: "Erro ao exportar votantes",
                    deleteError: "Erro ao eliminar o votante",
                    deleteSuccess: "Votante eliminado",
                    multipleDeleteSuccess: "Votantes eliminados",
                    manualVerificationError: "Erro ao verificar manualmente o votante",
                    manualVerificationSuccess: "Votante verificado manualmente con éxito, descargando PDF...",
                },
            },
            roles: {
                title: "Roles",
                edit: {
                    title: "Datos do Rol",
                    subtitle: "Ver e editar rol",
                },
                create: {
                    title: "Rol",
                    subtitle: "Crear rol",
                },
                errors: {
                    createError: "Erro ao crear o rol",
                    createSuccess: "Rol creado",
                },
                fields: {
                    name: "Nome",
                },
                delete: {
                    body: "¿Estás seguro de que queres eliminar este rol?",
                },
                notifications: {
                    deleteError: "Erro ao eliminar o rol",
                    deleteSuccess: "Rol eliminado",
                    permissionEditError: "Erro ao editar o permiso",
                    permissionEditSuccess: "Permiso editado",
                },
            },
            permissions: {
                "voter-information-letter": "Xerar Carta de información para o votante",
                "admin-user": "Administración",
                "admin-dashboard-view": "Vista del Panel de Administración",
                "application-export": "Exportación de Aplicaciones",
                "application-import": "Importación de Aplicaciones",
                "tenant-create": "Crear Inquilino",
                "tenant-read": "Leer Inquilino",
                "tenant-write": "Editar Inquilino",
                "election-event-create": "Crear Evento Electoral",
                "election-event-read": "Leer Evento Electoral",
                "election-event-write": "Editar Evento Electoral",
                "keycloak-realm-attributes-read": "Read Keycloak realm attributes",
                "keycloak-realm-attributes-write": "Edit Keycloak realm attributes",
                "election-event-delete": "Eliminar Evento Electoral",
                "voter-create": "Crear Votante",
                "voter-read": "Leer Votante",
                "voter-write": "Editar Votante",
                "voter-secret-attribute-read": "Mostrar Campos Secretos do Votante",
                "voter-secret-attribute-write": "Editar Campos Secretos do Votante",
                "user-create": "Crear Usuario",
                "user-read": "Leer Usuario",
                "user-write": "Editar Usuario",
                "user-permission-create": "Crear Permiso de Usuario",
                "user-permission-read": "Leer Permiso de Usuario",
                "user-permission-write": "Editar Permiso de Usuario",
                "role-create": "Crear Rol",
                "role-read": "Leer Rol",
                "role-write": "Editar Rol",
                "role-assign": "Asignar Rol",
                "communication-template-create": "Crear Plantilla de Comunicación",
                "communication-template-read": "Leer Plantilla de Comunicación",
                "communication-template-write": "Editar Plantilla de Comunicación",
                "notification-read": "Leer Notificación",
                "notification-write": "Editar Notificación",
                "notification-send": "Enviar Notificación",
                "area-read": "Leer Área",
                "area-write": "Editar Área",
                "election-state-write": "Editar Estado de Elección",
                "election-type-create": "Crear Tipo de Elección",
                "election-type-read": "Leer Tipo de Elección",
                "election-type-write": "Editar Tipo de Elección",
                "voting-channel-read": "Leer Canal de Votación",
                "voting-channel-write": "Editar Canal de Votación",
                "trustee-create": "Crear Fideicomisario",
                "trustee-read": "Leer Fideicomisario",
                "trustee-write": "Editar Fideicomisario",
                "tally-read": "Leer Recuento",
                "tally-start": "Iniciar Recuento",
                "tally-write": "Editar Recuento",
                "tally-results-read": "Leer Resultados de Recuento",
                "publish-read": "Leer Publicación",
                "publish-write": "Editar Publicación",
                "publish-results-read": "Leer Publicación de Resultados",
                "publish-results-write": "Editar Publicación de Resultados",
                "logs-read": "Leer Registros",
                "tasks-read": "Leer la Ejecución de Tareas",
                "keys-read": "Leer Claves",
                "document-upload": "Subir Documentos",
                "document-download": "Descargar Documentos",
                "document-password-read": "Ler contrasinais de documentos",
                "tally-sheet-create": "Crear Acta de Recuento",
                "tally-sheet-import-create": "Crear importación de actas de reconto",
                "tally-sheet-import-review": "Revisar importación de actas de reconto",
                "tally-sheet-import-view": "Ver importación de actas de reconto",
                "tally-recount-execute": "Executar reconto de resultados",
                "trustee-ceremony": "Ceremonia de Fideicomisario",
                "tally-sheet-review": "Revisar folla de reconto",
                "tally-sheet-view": "Ver Acta de Recuento",
                "admin-ceremony": "Administrar Ceremonia de Claves",
                "tally-sheet-delete": "Borrar Acta de Recuento",
                "cast-vote-read": "Leer Votos Emitidos",
                "document-read": "Leer Documentos",
                "document-write": "Editar Documentos",
                "support-material-read": "Leer Materiales de Soporte",
                "support-material-write": "Editar Materiales de Soporte",
                "miru-create": "Miru Create",
                "miru-download": "Miru Download",
                "miru-send": "Miru Send",
                "miru-sign": "Miru Sign",
                "contest-write": "Editar Concurso",
                "contest-read": "Leer Concurso",
                "candidate-write": "Editar Candidatos",
                "candidate-read": "Leer Candidatos",
                "permission-label-write": "Editar la etiqueta de permiso",
                "scheduled-event-write": "Editar Eventos Programados",
                "contest-create": "Create Contest",
                "contest-delete": "Delete Contest",
                "candidate-create": "Create Candidate",
                "candidate-delete": "Delete Candidate",
                "election-create": "Create Election",
                "election-read": "Read Election",
                "election-write": "Edit Election",
                "election-delete": "Delete Election",
                "election-event-archive": "Archive Election Event",
                "election-data-tab": "Ver Datos de la Elección",
                "election-event-areas-tab": "Ver Áreas del Evento Electoral",
                "election-event-data-tab": "Ver Datos del Evento Electoral",
                "election-event-keys-tab": "Ver Claves del Evento Electoral",
                "election-event-logs-tab": "Ver Registros del Evento Electoral",
                "election-event-publish-tab": "Ver Publicación del Evento Electoral",
                "election-event-reports-tab": "Ver Informes del Evento Electoral",
                "election-event-scheduled-tab": "Ver Programación del Evento Electoral",
                "election-event-tally-tab": "Ver Escrutinio del Evento Electoral",
                "election-event-tasks-tab": "Ver Tareas del Evento Electoral",
                "election-event-voters-tab": "Ver Votantes del Evento Electoral",
                "election-publish-tab": "Ver Publicación de la Elección",
                "election-voters-tab": "Ver Votantes de la Elección",
                "report-write": "Editar Informes",
                "report-read": "Leer Informes",
                "users-menu": "Ver usuarios y roles",
                "settings-menu": "Ver configuración",
                "templates-menu": "Ver plantillas",
                "settings-election-types-tab": "Ver configuración de tipos de elección",
                "settings-voting-channels-tab": "Ver configuración de canales de votación",
                "settings-templates-tab": "Ver configuración de plantillas",
                "settings-languages-tab": "Ver configuración de idiomas",
                "settings-localization-tab": "Ver configuración de localización",
                "settings-look-feel-tab": "Ver configuración de apariencia",
                "settings-trustees-tab": "Ver configuración de fideicomisarios",
                "settings-countries-tab": "Ver configuración de países",
                "voter-import": "Importar Votante",
                "ee-voters-columns": "Ver Columnas de Votantes del Evento Electoral",
                "voter-manually-verify": "Verificar Votante Manualmente",
                "ee-voters-logs": "Ver Registros de Votantes del Evento Electoral",
                "voter-export": "Exportar Votante",
                "ee-voters-filters": "Ver Filtros de Votantes del Evento Electoral",
                "voter-delete": "Eliminar Votante",
                "voter-change-password": "Cambiar la Contraseña del Votante",
                "election-event-localization-selector": "Selector de Localización del Evento Electoral",
                "localization-create": "Crear Localización",
                "localization-read": "Leer Localización",
                "localization-write": "Editar Localización",
                "localization-delete": "Eliminar Localización",
                "area-create": "Crear Área",
                "area-delete": "Eliminar Área",
                "area-export": "Exportar Área",
                "area-import": "Importar Área",
                "area-upsert": "Insertar o Actualizar Área",
                "election-event-areas-columns": "Columnas de las Áreas del Evento Electoral",
                "election-event-areas-filters": "Filtros de las Áreas del Evento Electoral",
                "election-event-tasks-back-button": "Volver a las Tareas del Evento Electoral",
                "election-event-tasks-columns": "Columnas de las Tareas del Evento Electoral",
                "election-event-tasks-filters": "Filtros de las Tareas del Evento Electoral",
                "task-export": "Exportar Tareas",
                "application-read": "Leer Aplicación",
                "application-write": "Editar Aplicación",
                "logs-export": "Exportar Registros",
                "election-event-logs-columns": "Columnas de los Registros del Evento Electoral",
                "election-events-logs-filters": "Filtros de los Registros del Evento Electoral",
                "election-event-scheduled-event-columns": "Columnas de los Eventos Programados del Evento Electoral",
                "scheduled-event-create": "Crear Evento Programado",
                "scheduled-event-delete": "Eliminar Evento Programado",
                "election-event-reports-columns": "Columnas de los Informes del Evento Electoral",
                "report-create": "Crear Informe",
                "report-delete": "Eliminar Informe",
                "report-generate": "Generar Informe",
                "report-preview": "Vista Previa del Informe",
                "monitor-authenticated-voters": "Monitoreo de Votantes Autenticados",
                "monitor-all-approve-disapprove-voters": "Leer Monitoreo de Votantes Aprobados y Rechazados",
                "monitor-automatic-approve-disapprove-voters": "Leer Monitoreo de Aprobaciones y Rechazos Automáticos",
                "monitor-manually-approve-disapprove-voters": "Leer Monitoreo de Aprobaciones y Rechazos Manuales",
                "monitor-enrolled-overseas-voters": "Leer Monitoreo de Votantes Inscritos en el Extranjero",
                "monitor-posts-already-closed-voting": "Leer Monitoreo de Publicaciones con Votación Cerrada",
                "monitor-posts-already-generated-election-results": "Leer Monitoreo de Publicaciones con Resultados Generados",
                "monitor-posts-already-opened-voting": "Leer Monitoreo de Publicaciones con Votación Abierta",
                "monitor-posts-already-started-counting-votes": "Leer Monitoreo de Publicaciones que Comenzaron a Contar Votos",
                "monitor-posts-initialized-the-system": "Leer Monitoreo de Publicaciones que Inicializaron el Sistema",
                "monitor-posts-started-voting": "Leer Monitoreo de Publicaciones que Comenzaron a Votar",
                "monitor-posts-transmitted-results": "Leer Monitoreo de Publicaciones que Transmitieron Resultados",
                "monitor-voters-voted-test-election": "Leer Monitoreo de Votantes en Elección de Prueba",
                "monitor-voters-who-voted": "Leer Monitoreo de Votantes que Votaron",
                "election-event-publish-preview": "Vista Previa de la Publicación del Evento Electoral",
                "election-event-publish-back-button": "Volver a la Publicación del Evento Electoral",
                "election-event-publish-columns": "Columnas de la Publicación del Evento Electoral",
                "election-event-publish-filters": "Filtros de la Publicación del Evento Electoral",
                "publish-create": "Crear Publicación",
                "publish-regenerate": "Regenerar Publicación",
                "publish-export": "Exportar Publicación",
                "publish-start-voting": "Iniciar Votación",
                "publish-pause-voting": "Pausar Votación",
                "publish-stop-voting": "Detener Votación",
                "publish-changes": "Publicar Cambios",
                "election-event-publish-view": "Ver Publicación del Evento Electoral",
                "election-event-keys-columns": "Columnas de las Claves del Evento Electoral",
                "create-ceremony": "Crear Ceremonia",
                "export-ceremony": "Exportar Ceremonia",
                "election-event-tally-columns": "Columnas del Recuento del Evento Electoral",
                "election-event-tally-back-button": "Volver al Recuento del Evento Electoral",
                "transmition-ceremony": "Ceremonia de Transmisión",
                "admin-ip-address-view": "Ver Dirección IP",
                "election-approvals-tab": "Ver Aprobaciones de la Elección",
                "election-event-approvals-tab": "Ver Aprobaciones del Evento Electoral",
                "election-ip-address-view": "Ver Dirección IP de la Elección",
                "election-dashboard-tab": "Ver Dashboard de la Elección",
                "trustees-export": "Exportar Fideicomisarios",
                "user-import": "Importar Usuarios",
                "voter-voted-edit": "Editar a los votantes que votaron",
                "voter-email-tlf-edit": "Editar email/teléfono de los votantes",
                "cloudflare-write": "Editar las reglas de bloqueo por país en Cloudflare",
                "transmission-report-generate": "Generar Informe de Transmisión",
                "google-meet-link": "Xerar Ligazón de Google Meet",
                "service-account": "Conta de servizo",
                "datafix-account": "Conta de corrección de datos",
                "gold": "Ouro",
                "silver": "Prata",
                "election-event-ivr-tab": "Ver IVR do evento electoral",
                "election-event-cas-tab": "Ver CAS do evento electoral",
                "ca-read": "Consultar autoridades de certificación",
                "ca-write": "Editar autoridades de certificación",
                "generate-preview": "Xerar vista previa",
                "preview-read": "Consultar vista previa",
                "tally-resolution-submit": "Enviar resolución do escrutinio",
                "phone-blacklist-read": "Consultar lista negra de teléfonos",
                "phone-blacklist-create": "Crear entradas na lista negra de teléfonos",
                "phone-blacklist-update": "Editar entradas da lista negra de teléfonos",
                "phone-blacklist-delete": "Eliminar entradas da lista negra de teléfonos",
                "election-event-voter-list-reconciliation": "Reconciliar a lista de votantes do evento electoral",
            },
        },
        generalSettingsScreen: {
            body: "Activa idiomas no sistema. Só os idiomas activados aquí estarán dispoñibles para eventos electorais.",
        },
        eventsScreen: {
            title: "Eventos Programados",
            subtitle: "Xestiona a configuración da execución automática de eventos como o inicio ou fin do período de votación.",
            messages: {
                createSuccess: "Evento Programado creado correctamente",
                createError: "Erro ao crear o Evento Programado",
                editSuccess: "Evento Programado editado correctamente",
                editError: "Erro ao editar o Evento Programado",
            },
            eventType: {
                label: "Tipo",
                ALLOW_INIT_REPORT: "Permitir Informe de Inicialización",
                START_VOTING_PERIOD: "Inicio do Período de Votación",
                END_VOTING_PERIOD: "Fin do Período de Votación",
                ALLOW_VOTING_PERIOD_END: "Permitir Fin do Período de Votación",
                START_ENROLLMENT_PERIOD: "Inicio do Período de Rexistro",
                END_ENROLLMENT_PERIOD: "Fin do Período de Rexistro",
                START_LOCKDOWN_PERIOD: "Inicio do Período de Bloqueo",
                END_LOCKDOWN_PERIOD: "Fin do Período de Bloqueo",
                ALLOW_TALLY: "Permitir Recuento",
            },
            election: {
                label: "Elección",
            },
            empty: {
                header: "Aínda non hai Eventos Programados.",
                body: "¿Queres crear un?",
                button: "Crear Evento Programado",
            },
            create: {
                title: "Crear Evento Programado",
                subtitle: "Crear unha nova configuración de Evento Programado.",
            },
            edit: {
                title: "Editar Evento Programado",
                subtitle: "Editar configuración do Evento Programado.",
                delete: "¿Estás seguro de que queres eliminar este Evento Programado?",
            },
            fields: {
                electionId: "Elección",
                eventProcessor: "Tipo",
                stoppedAt: "Detido o",
                scheduledDate: "Programado para",
            },
        },
        reportsScreen: {
            title: "Informes",
            subtitle: "Xerar informes para os eventos electorais",
            messages: {
                createSuccess: "Informe creado correctamente",
                createError: "Erro ao crear o Informe",
                submitError: "Erro ao enviar o Informe",
                updateSuccess: "Informe actualizado correctamente",
                passwordMismatch: "Las contraseñas no coinciden. Asegúrate de que ambos campos contengan la misma contraseña.",
                incorectPassword: "Contraseña incorrecta",
                decryptFileTitle: "Descifrar archivo",
                decryptInstructions: "1. '-in': La ruta al archivo cifrado. \n2. '-out': La ruta donde se guardará el archivo descifrado. \n3. '-pass': La contraseña utilizada para cifrar el archivo. \n",
                encryptSuccess: "Configuración do cifrado do informe realizada con éxito",
                encryptError: "Erro ao configurar o cifrado do informe",
            },
            reportType: {
                BALLOT_RECEIPT: "Recibo da Papeleta",
                ELECTORAL_RESULTS: "Resultados Electorais",
                MANUAL_VERIFICATION: "Verificación Manual",
                PARTICIPATION_REPORT: "Informe de Participación",
                STATISTICAL_REPORT: "Informe Estatístico",
                OVCS_EVENTS: "Monitorización de Votación no Estranxeiro - Eventos OVCS",
                AUDIT_LOGS: "Rexistros de Auditoría",
                ACTIVITY_LOG: "Rexistro de Actividade",
                STATUS: "Estado",
                OVCS_INFORMATION: "Información de OVCS",
                OVERSEAS_VOTERS: "Lista de votantes no estranxeiro",
                OV_USERS_WHO_VOTED: "Lista de Votantes no Estranxeiro que Votaron",
                OV_WITH_VOTING_STATUS: "Lista de Votantes en el Extranjero con Estado de Votación",
                OVCS_STATISTICS: "Monitorización de Votación no Estranxeiro - Estatísticas OVCS",
                PRE_ENROLLED_OV_BUT_DISAPPROVED: "Lista de Votantes no Estranxeiro que se Preinscribiron pero Non Aprobados",
                PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION: "Lista de Votantes no Estranxeiro que se Preinscribiron pero suxeitos a Validación Manual",
            },
            reportEncryptionPolicy: {
                title: "Política de cifrado",
                UNENCRYPTED: "Sin cifrar",
                CONFIGURED_PASSWORD: "Contraseña configurada",
            },
            empty: {
                header: "Aínda non hai Informes.",
                body: "¿Queres crear un?",
                button: "Crear Informe",
            },
            create: {
                title: "Crear Informe",
                subtitle: "Crear unha nova configuración de Informe.",
            },
            edit: {
                title: "Editar Informe",
                subtitle: "Editar configuración do Informe.",
                delete: "¿Estás seguro de que queres eliminar este Informe?",
            },
            fields: {
                electionId: "Elección",
                template: "Modelo",
                reportType: "Tipo de Informe",
                repeatable: "Repetible",
                cronExpression: "Expresión Cron",
                emailRecipients: "Destinatarios de Correo",
                emailRecipientsPlaceholder: "Escribe o correo e presiona Enter",
            },
            delete: {
                body: "¿Estás seguro de que queres eliminar este Informe?",
            },
            actions: {
                generate: "Xerar",
                delete: "Eliminar",
                edit: "Editar",
                preview: "Vista Previa",
            },
        },
        googleMeet: {
            title: "Xerar Ligazón de Google Meet",
            generateButton: "Google Meet",
            meetingTitle: "Título da Reunión",
            description: "Descrición (Opcional)",
            startDate: "Data de Inicio",
            startTime: "Hora de Inicio",
            duration: "Duración (minutos)",
            attendeeEmails: "Emails dos Participantes",
            attendeeEmailHelp: "Emails separados por comas para os participantes da reunión",
            note: "Nota: Isto creará un evento de calendario no teu Google Calendar cun enlace de Google Meet. Necesitarás iniciar sesión na túa conta de Google.",
            success: "Ligazón de Google Meet Xerada con Éxito!",
            copy: "Copiar ao portapapeis",
            copied: "Ligazón copiada ao portapapeis!",
            instructions: "Comparte esta ligazón cos participantes para unirse á reunión. O evento de calendario foi engadido ao teu Google Calendar.",
            generating: "Xerando...",
            generate: "Xerar Ligazón de Meet",
        },
        common: {
            export: "A exportación pode ser unha operación longa. ¿Estás seguro de que queres exportar os rexistros?",
            resources: {
                electionEvent: "Evento Electoral",
                election: "Elección",
                contest: "Concurso",
                candidate: "Candidato",
                noResult: {
                    askCreate: "¿Queres crear un?",
                },
            },
            label: {
                add: "Engadir",
                actions: "Accións",
                create: "Crear",
                delete: "Eliminar",
                archive: "Arquivar",
                unarchive: "Desarquivar",
                cancel: "Cancelar",
                edit: "Editar",
                yes: "Si",
                no: "Non",
                save: "Gardar",
                close: "Pechar",
                back: "Atrás",
                next: "Seguinte",
                warning: "Aviso",
                json: "Vista Previa",
                noResult: "Sen resultados",
                import: "Importar",
                export: "Exportar",
                loadingData: "Cargando datos...",
                exportFormat: "Exportar en formato {{format}} - Resultados de '{{item}}'",
                allResults: "evento electoral",
                globalAreaResults: "todas as áreas",
                title: "Título",
                subtitle: "Subtítulo",
                kind: "Tipo de ficheiro",
                filter: "Filtros Personalizados",
                approve: "Aprobar",
                continue: "Continuar",
                logout: "Pechar sesión",
                selectTenant: "Seleccionar cliente",
                processing: "Procesando...",
                tenantName: "Nome do inquilino",
            },
            language: {
                es: "Español",
                en: "Inglés",
                fr: "Francés",
                cat: "Valenciano",
                tl: "Tagalo",
                gl: "Galego",
                nl: "Holandés",
                eu: "Euskera",
            },
            channel: {
                online: "En Liña",
                kiosk: "Quiosco",
                early_voting: "Votación anticipada",
                telephone: "Votación telefónica",
                other: "Outros",
            },
            message: {
                delete: "¿Estás seguro de que queres eliminar este elemento?",
                continueOrLogout: "¿Queres continuar ou pechar sesión?",
            },
        },
        createResource: {
            electionEvent: "Crear un Evento Electoral",
            election: "Crear unha Elección",
            contest: "Crear un Concurso",
            candidate: "Crear un Candidato",
        },
        importResource: {
            electionEvent: "Importar un Evento Electoral",
            election: "Importar una Elección",
            contest: "Importar un Concurso",
            candidate: "Importar un Candidato",
            ImportHashMismatch: "Hashes don't match. Integrity check failure.",
        },
        sideMenu: {
            electionEvents: "Eventos Electorais",
            search: "Buscar",
            usersAndRoles: "Usuarios e Roles",
            logs: "Rexistros",
            settings: "Configuracións",
            help: "Axuda",
            templates: "Modelos",
            active: "Activo",
            archived: "Arquivado",
            addResource: {
                electionEvent: "Crear un Evento Electoral",
                election: "Crear unha Elección",
                contest: "Crear un Concurso",
                candidate: "Crear un Candidato",
            },
            menuActions: {
                archive: {
                    electionEvent: "Arquivar este Evento Electoral",
                },
                unarchive: {
                    electionEvent: "Desarquivar este Evento Electoral",
                    election: "Desarquivar esta Elección",
                    contest: "Desarquivar este Concurso",
                    candidate: "Desarquivar este Candidato",
                },
                remove: {
                    electionEvent: "Eliminar este Evento Electoral",
                    election: "Eliminar esta Elección",
                    contest: "Eliminar este Concurso",
                    candidate: "Eliminar este Candidato",
                },
                messages: {
                    confirm: {
                        archive: "¿Estás seguro de que queres arquivar este elemento?",
                        unarchive: "¿Estás seguro de que queres desarquivar este elemento?",
                        delete: "¿Estás seguro de que queres eliminar este elemento?",
                    },
                    notification: {
                        success: {
                            archive: "O elemento foi arquivado",
                            unarchive: "O elemento foi desarquivado",
                            delete: "O elemento foi eliminado",
                            reloading: "Espere. La página se recargara en unos momentos",
                        },
                        error: {
                            archive: "Erro ao tentar arquivar este elemento",
                            unarchive: "Erro ao tentar desarquivar este elemento",
                            delete: "Erro ao tentar eliminar este elemento",
                        },
                    },
                },
            },
        },
        candidateScreen: {
            common: {
                subtitle: "Configuración do candidato.",
            },
            edit: {
                externalId: "ID externo",
                general: "Xeral",
                type: "Tipo",
                image: "Imaxe",
                isDisabled: "Desactivado",
                isExplicitInvalid: "Voto Nulo",
                isExplicitBlank: "Voto en Branco",
                isCategoryList: "Lista de Categoría",
                isWriteIn: "Escrita",
            },
            field: {
                name: "Nome",
                alias: "Alias",
                description: "Descrición",
            },
            options: {
                "candidate": "Candidato",
                "option": "Opción",
                "write-in": "Escrita",
                "open-list": "Lista Aberta",
                "closed-list": "Lista Pechada",
                "semi-open-list": "Lista Semi Aberta",
                "invalid-vote": "Voto Nulo",
                "blank-vote": "Voto en Branco",
            },
            invalidVotePosition: {
                label: "Posición do Voto Nulo",
                null: "Ningunha (Por defecto)",
                top: "Arriba",
                bottom: "Abaixo",
            },
            error: {},
            createCandidateSuccess: "Candidato creado",
            createCandidateError: "Erro ao crear o candidato",
        },
        contestScreen: {
            common: {
                subtitle: "Configuración do concurso.",
            },
            edit: {
                externalId: "ID externo",
                general: "Xeral",
                type: "Tipo",
                image: "Imaxe",
                system: "Sistema de Votación en Papeleta",
                design: "Deseño da Papeleta",
                reorder: "Reordenar candidatos",
                policies: "Políticas",
            },
            field: {
                name: "Nome",
                alias: "Alias",
                description: "Descrición",
            },
            options: {
                "non-preferential": "Non Preferencial",
                "plurality-at-large": "Pluralidade en Xeral",
                "instant-runoff": "Segunda Volta Instantánea",
                "random": "Aleatorio",
                "external-procedure": "Procedemento externo",
                "custom": "Personalizado",
                "alphabetical": "Alfabético",
            },
            tieBreakingPolicy: {
                label: "Política de desempate",
            },
            auditButtonConfig: {
                "label": "Opcións de Visualización do Botón de Auditoría",
                "show": "Mostrar",
                "not-show": "Non Mostrar",
                "show-in-help": "Mostrar na Ventá de Axuda",
            },
            underVotePolicy: {
                "label": "Política de Voto Inferior",
                "allowed": "Permitido",
                "warn-only-in-review": "Avisar na Revisión",
                "warn": "Avisar",
                "warn-and-alert": "Avisar e Alertar",
            },
            invalidVotePolicy: {
                "label": "Política de Voto Nulo",
                "allowed": "Permitido",
                "warn": "Avisar",
                "warn-invalid-implicit-and-explicit": "Avisar Votos Nulos Implícitos e Explícitos",
                "not-allowed": "Non Permitido",
                "allowed-with-exclusive-explicit": "Permitido con Voto Nulo Explícito Exclusivo",
            },
            candidatesIconCheckboxPolicy: {
                "label": "Forma do Icono de Caixa de Selección dos Candidatos",
                "square-checkbox": "Caixa de Selección Cadrada",
                "round-checkbox": "Caixa de Selección Redonda",
            },
            checkableListPolicy: {
                "allow-selecting-candidates-and-lists": "Candidatos e Listas",
                "allow-selecting-candidates": "Só Candidatos",
                "allow-selecting-lists": "Só Listas",
                "disabled": "Desactivado",
            },
            collapsibleListsPolicy: {
                "label": "Listas plegables",
                "disabled": "Deshabilitado",
                "enabled-expanded": "Habilitado (comeza expandido)",
                "enabled-collapsed": "Habilitado (comeza contraído)",
            },
            blankVotePolicy: {
                "label": "Política de Voto en Branco",
                "allowed": "Permitido",
                "warn-only-in-review": "Avisar na Revisión",
                "warn": "Avisar",
                "not-allowed": "Non Permitido",
            },
            overVotePolicy: {
                "label": "Política de Sobrescritura de Voto",
                "allowed": "Permitido",
                "allowed-with-msg": "Permitido con Mensaxe de Aviso",
                "allowed-with-msg-and-alert": "Permitido con Mensaxe de Aviso e Alerta",
                "not-allowed-with-msg-and-alert": "Non Permitido con Mensaxe de Aviso e Alerta",
                "not-allowed-with-msg-and-disable": "Non Permitido con Mensaxe de Aviso e Desactivar seleccións adicionais",
            },
            duplicatedRankPolicy: {
                "label": "Voto non válido - Política de posición duplicada",
                "allowed-warn-and-dialog": "Mostrar aviso e diálogo (o votante pode continuar)",
                "not-allowed-warn-and-dialog": "Mostrar aviso e diálogo (o votante non pode continuar)",
            },
            preferenceGapsPolicy: {
                "label": "Voto non válido - Política de rangos omitidos",
                "allowed-warn-and-dialog": "Mostrar aviso e diálogo (o votante pode continuar)",
                "not-allowed-warn-and-dialog": "Mostrar aviso e diálogo (o votante non pode continuar)",
            },
            paginationPolicy: {
                label: "Nome da Páxina",
            },
            isAcclaimed: {
                label: "Resolto por aclamación",
                helperText: "Os votantes ven este concurso pero non poden seleccionar nada, non se rexistra nada e todas as candidaturas se declaran gañadoras con cero votos. Configúreo antes de publicar as papeletas: cambialo despois invalida as papeletas xa emitidas.",
            },
            allowWriteins: {
                label: "Permitir candidaturas manuais",
            },
            maxVotes: {
                helperText: "Número máximo de candidatos que un votante pode seleccionar (votación non preferencial).",
                helperTextPreferential: "Posición de rango máis alta dispoñible para os votantes (ex. '5' significa posicións 1–5). Debe ser polo menos igual ao número de candidatos a ordenar (votación preferencial).",
            },
            error: {},
            createContestSuccess: "Concurso creado",
            createContestError: "Erro ao crear o concurso",
        },
        keysGeneration: {
            configureStep: {
                create: "Crear Cerimonia de Chaves",
                name: "Nome da Cerimonia de Chaves",
                allElections: "Todas as Eleccións",
                title: "Crear Cerimonia de Chaves do Evento Electoral",
                subtitle: "Na Cerimonia de Chaves, cada fiduciario xerará e descargará o seu fragmento da chave privada para o Evento Electoral. Para continuar, por favor elixe os fiduciarios que participarán na cerimonia e o limiar, que é o número mínimo de fiduciarios requiridos para o escrutinio.",
                trusteeList: "Fiduciarios",
                threshold: "Limiar",
                errorMinTrustees_one: "Seleccionaches só {{selected}} fiduciario, pero debes seleccionar polo menos {{threshold}}.",
                errorMinTrustees_other: "Seleccionaches só {{selected}} fiduciarios, pero debes seleccionar polo menos {{threshold}}.",
                errorThreshold: "Seleccionaches un limiar de {{selected}}, pero debe estar entre {{min}} e {{max}}.",
                errorCreatingCeremony: "Erro ao crear a Cerimonia de Chaves: {{error}}",
                createCeremonySuccess: "Cerimonia de Chaves creada",
                confirmdDialog: {
                    ok: "Si, Crear Cerimonia de Chaves",
                    cancel: "Cancelar",
                    title: "¿Estás seguro de que queres Crear a Cerimonia de Chaves?",
                    automaticCeremonyTitle: "¿Estás seguro de que queres crear unha cerimonia de chaves automática?",
                    description: "Estás a piques de Crear a Cerimonia de Chaves. Esta acción notificará aos Fiduciarios para participar na creación e distribución das Chaves do Evento Electoral.",
                    automaticCeremonyDescription: "Estás a piques de crear unha cerimonia de chaves automática. Isto non notificará aos fideicomisarios para que participen.",
                },
                filterTrustees: "Filtrar Autoridades",
                errorPermisionLabels: "Non se pode crear a cerimonia de chaves: falta unha ou máis etiquetas de permisos.",
                automaticCeremonyToggle: "Ceremonia automática",
            },
            ceremonyStep: {
                cancel: "Cancelar Cerimonia de Chaves",
                progressHeader: "Progreso da Cerimonia de Chaves",
                description: "Esta pantalla mostra o progreso e os rexistros da Cerimonia de Chaves do Evento Electoral. Na Cerimonia de Chaves, cada fiduciario xerará e descargará o seu fragmento da chave privada para o Evento Electoral.",
                executionStatus: "Estado: {{status}}",
                confirmdDialog: {
                    ok: "Si, Cancelar a Cerimonia de Chaves",
                    cancel: "Volver á Cerimonia de Chaves",
                    title: "¿Estás seguro de que queres Cancelar a Cerimonia de Chaves?",
                    description: "Estás a piques de Cancelar a Cerimonia de Chaves. Despois de realizar esta acción, para ter unha Cerimonia de Chaves exitosa terás que crear unha nova.",
                },
                header: {
                    trusteeName: "Nome do Fiduciario",
                    fragment: "Fragmento de Chave Xerado",
                    downloaded: "Fragmento de Chave Privada Descargado",
                    checked: "Fragmento de Chave Privada Verificado",
                },
                logsHeader: {
                    title: "Rexistros",
                    date: "Data",
                    entry: "Entrada",
                },
                emptyLogs: "Aínda non hai rexistros.",
            },
            startStep: {
                title: "Cerimonia de Chaves do Fiduciario",
                subtitle: "Estás a piques de participar na Cerimonia de Chaves como Fiduciario (<strong>{{name}}</strong>). Isto implica os seguintes pasos:",
                one: "<strong>Descargar</strong> a túa Chave Privada Cifrada.",
                two: "Crear múltiples <strong>Copias de Seguridade</strong> da Chave Privada Cifrada.",
                three: "<strong>Verificar</strong> que as copias de seguridade funcionan correctamente.",
            },
            downloadStep: {
                title: "Descargar Chave Privada Cifrada",
                subtitle: "Para continuar, por favor descarga e almacena a túa Chave Privada Cifrada en polo menos dous dispositivos diferentes:",
                downloadButton: "Descargar a túa Chave Privada Cifrada",
                errorDownloading: "Erro de descarga: {{error}}",
                errorEmptyKey: "Erro de descarga, ficheiro baleiro",
                confirmdDialog: {
                    ok: "Confirmar Copias de Seguridade e Continuar",
                    cancel: "Volver Atrás",
                    title: "Fai unha Copia de Seguridade da túa Chave Privada Cifrada",
                    description: "Por favor, fai unha copia de seguridade da túa Chave Privada Cifrada en polo menos dous lugares seguros diferentes e logo confírmao abaixo:",
                    firstCopy: "Primeira copia de seguridade gardada",
                    secondCopy: "Segunda copia de seguridade gardada",
                    confirmError: "Create required backups and check the confirmation boxes to continue",
                },
            },
            checkStep: {
                title: "Verificar as túas Copias de Seguridade da Chave Privada Cifrada",
                subtitle: "Carga unha Copia de Seguridade da Chave Privada Cifrada para comprobar que é correcta. Podes probar tantas veces como necesites, desde as túas diferentes copias de seguridade:",
                errorUploading: "Copia de Seguridade da Chave Privada Cifrada inválida, por favor intenta de novo",
                errorEmptyFile: "Ficheiro baleiro ou non atopado",
                verified: "Copia de seguridade verificada correctamente.",
                downloaded: "Chave Privada Cifrada xerada correctamente.",
            },
        },
        miruExport: {
            create: {
                success: "Creando Paquete de Transmisión...",
                error: "Erro ao crear o Paquete de Transmisión ",
            },
            send: {
                success: "Enviando Paquete de Transmisión...",
                error: "Erro ao enviar o Paquete de Transmisión ",
            },
        },
        tally: {
            errorUploadingSignature: "Houbo un erro ao cargar a sinatura",
            downloadTransmissionPackage: "Descargar Paquete de Transmisión",
            resultsPublication: {
                sectionTitle: "Publish to results website",
                policyTitle: "Results Website",
                policyAccess: "Results Website Access",
                policyVisibility: "Results Website Visibility",
                enabled: "Enabled",
                disabled: "Disabled",
                fullEvent: "Full event",
                areaBased: "Area based",
                publishStarted: "Results publication started",
                publishError: "Could not start results publication",
                revoked: "Results publication revoked",
                revokeError: "Could not revoke results publication",
                waitingForTally: "Results can be published after this tally has completed.",
                writePermissionRequired: "You need publish-results-write permission to publish or revoke results.",
                readPermissionRequired: "You need publish-results-read permission to view publication history.",
                disabledPolicy: "Results website publishing is disabled for this election event. Enable it in the election event data before publishing results.",
                loadingElectionContext: "Results publication is loading election context.",
                route: "Route",
                eventResults: "Event results",
                electionResults: "Election results",
                election: "Election",
                access: "Access",
                publicAccess: "Public access",
                authenticatedAccess: "Authenticated access",
                visibility: "Visibility",
                fullPublishedScope: "Full published scope",
                personalVisibility: "Personal visibility",
                contests: "Contests",
                noTalliedContests: "No tallied contests available.",
                publishSelectedContests: "Publish selected contests",
                selectedContestCount: "{{count}} contest selected",
                selectedContestCount_plural: "{{count}} contests selected",
                history: "Publication history",
                version: "Version",
                status: "Status",
                published: "Published",
                revokedAt: "Revoked",
                actions: "Actions",
                open: "Open",
                revoke: "Revoke",
                noPublications: "No publications yet.",
                confirmTitle: "Start publish to results website?",
                confirmDescription: "This will create a new publication from the current tally execution. The existing voter-facing results stay active until this publish task succeeds.",
                close: "Close",
            },
            transmissionPackage: {
                title: "Paquete de Transmisión para a Área '{{name}}' e Elección '{{eventName}}'",
                description: "Permítelle exportar un Paquete de Transmisión a Servidores de Destino ou descargalo.",
                actions: {
                    send: {
                        title: "Enviar",
                        dialog: {
                            title: "¿Queres Enviar o Paquete de Transmisión?",
                            description: "Por favor, confirme que quere Enviar o Paquete de Transmisión para a Área `{{name}}` aos Servidores de Destino.",
                            confirm: "Enviar Paquete de Transmisión",
                            cancel: "Pechar",
                        },
                    },
                    regenerate: {
                        title: "Rexenerar",
                        dialog: {
                            title: "¿Queres rexenerar o Paquete de Transmisión?",
                            description: "Por favor, confirme que quere rexenerar o Paquete de Transmisión para a Área `{{name}}`",
                            confirm: "Rexenerar Paquete de Transmisión",
                            cancel: "Pechar",
                        },
                    },
                    sign: {
                        title: "Asinar",
                        dialog: {
                            title: "¿Queres asinar o Paquete de Transmisión?",
                            description: "Por favor, confirme que quere asinar o Paquete de Transmisión para a Área `{{name}}`",
                            confirm: "Asinar Paquete de Transmisión",
                            cancel: "Pechar",
                            input: {
                                placeholder: "Introduce o teu contrasinal",
                            },
                        },
                    },
                    download: {
                        title: "Descargar",
                        emlTitle: "Descargar EML",
                        transmissionPackageTitle: "Descargar Paquete de Transmisión",
                        transmissionReportTitle: "Descargar informe de transmisión",
                        dialog: {
                            title: "¿Queres Descargar o Paquete de Transmisión?",
                            description: "Por favor, confirme que quere Descargar o Paquete de Transmisión para a Área `{{name}}.`",
                            confirm: "Descargar Paquete de Transmisión",
                            cancel: "Pechar",
                        },
                    },
                },
                destinationServers: {
                    title: "Servidores de Destino",
                    description: "A táboa a continuación mostra o estado de envío de cada un dos Servidores de Destino.",
                    status: "Enviado a {{signed}} de {{total}}",
                    table: {
                        serverName: "Nome do Servidor",
                        sendStatus: "Estado de Envío",
                    },
                },
                signatures: {
                    title: "Sinaturas SBEI",
                    description: "Os membros SBEI poden asinar o Paquete de Transmisión. A táboa a continuación mostra o estado de sinatura de cada un dos membros SBEI.",
                    status: "{{signed}} de {{total}} Asinados, mínimo de {{minimum}}",
                    table: {
                        trusteeName: "Nome do Fiduciario",
                        signed: "Asinou",
                    },
                },
            },
            sendToTransmissionPackageServers: "Enviar Paquete de Transmisión para a Área '{{name}}'",
            uploadTransmissionPackage: "Asinar Paquete de Transmisión",
            uploadTransmissionPackageDesc: "Carga a túa Sinatura para asinar o Paquete de Transmisión. Esta é unha operación opcional.",
            exportElectionArea: "Enviar Paquete de Transmisión para a Área '{{name}}'",
            generateReport: "Generar {{name}}",
            templateTitle: "Modelo de Resultados",
            templateSubTitle: "Sobrescribir opcionalmente o modelo de resultados.",
            keysCeremonyTitle: "Cerimonia de Chaves",
            keysCeremonySubTitle: "Selecciona a Cerimonia de Chaves para este escrutinio",
            ceremonyTitle: "Eleccións para Escrutar",
            initializationTitle: "Eleccións para o Informe de Inicialización",
            ceremonySubTitle: "Elixe as eleccións que queres escrutar",
            tallyTitle: "Progreso do Escrutinio das Eleccións",
            logsTitle: "Rexistros",
            resultsTitle: "Resultados e Participación",
            generalInfoTitle: "Información Xeral",
            trusteeTallyTitle: "Fiduciarios",
            trusteeTallySubTitle: "Estado de importación do fragmento de chave",
            createTallySuccess: "Escrutinio creado",
            createTallyError: "Non se puido crear o Escrutinio",
            startTallySuccess: "Escrutinio iniciado",
            startTallyError: "Non se puido iniciar o Escrutinio",
            startTallyCeremonySuccess: "Cerimonia de Escrutinio iniciada",
            startTallyCeremonyError: "Non se puido iniciar a Cerimonia de Escrutinio",
            cancelTallyCeremonySuccess: "Cerimonia de Escrutinio cancelada",
            cancelTallyCeremonyError: "Non se puido cancelar a Cerimonia de Escrutinio",
            recountTallyCeremony: "Repetir o reconto",
            recountTallyCeremonyMessage: "Isto xerará un novo evento de resultados para a sesión de escrutinio completada.",
            recountTallyCeremonyStarting: "Iniciando o reconto...",
            recountTallyCeremonySuccess: "Reconto iniciado",
            recountTallyCeremonyError: "Non se puido iniciar o reconto",
            recountTallyCeremonyOk: "Repetir o reconto",
            trusteeTitle: "Proceso dos Fiduciarios",
            trusteeSubTitle: "Por favor, carga o teu fragmento de chave",
            invited: "Fostes invitado a participar nunha Cerimonia de Escrutinio. Por favor ",
            click: "fai clic na Acción de Escrutinio",
            participate: "para participar.",
            breadcrumbSteps: {
                start: "Inicio",
                finish: "Finalizar",
                tally: "Escrutinio",
                results: "Resultados",
                ceremony: "Cerimonia",
            },
            common: {
                title: "Escrutinio",
                subTitle: "Configuración do Escrutinio.",
                cancel: "Atrás",
                next: "Seguinte",
                date: "Data do Escrutinio",
                global: "Global",
                noTrustees: "Aínda non hai fiduciarios",
                imported: " fiduciarios importaron a chave",
                needed: " fiduciarios necesarios",
                start: "Iniciar Escrutinio",
                ceremony: "Iniciar Cerimonia de Escrutinio",
                initialization: "Iniciar Informe de Inicialización",
                results: "Resultados",
                dialog: {
                    ok: "Aceptar",
                    okTally: "Iniciar Escrutinio",
                    okCancel: "Cancelar Escrutinio",
                    cancel: "Pechar",
                    title: "¿Estás seguro de que queres iniciar unha cerimonia?",
                    tallyTitle: "¿Estás seguro de que queres iniciar o escrutinio?",
                    cancelTitle: "¿Estás seguro de que queres cancelar o escrutinio?",
                    message: "Estás a piques de iniciar unha cerimonia de escrutinio. Esta acción notificará aos fiduciarios para que importen os seus fragmentos de chave.",
                    cancelMessage: "Estás a piques de cancelar a cerimonia de escrutinio. Esta acción non se pode desfacer.",
                    ceremony: "Todos os fiduciarios requiridos verificaron os seus fragmentos de chave. Todo está listo para comezar a recibir resultados. ¿Queres iniciar o Escrutinio?",
                    startAutomatedTallyMessage: "Seleccione 'Start Tally' para executar o proceso de reconto e mostrar os resultados, ou 'Close' para cancelar.",
                },
            },
            table: {
                elections: "Eleccións",
                selected: "Seleccionado",
                status: "Estado",
                progress: "Progreso",
                method: "Método de Escrutinio",
                elegible: "Votantes Elixibles",
                number: "Número de Votos",
                total: "Total",
                turnout: "%",
                candidates: "Resultados dos Candidatos",
                options: "Opcións",
                global: "Resumo de Participación",
                elegible_census: "Votantes Elixibles",
                cast_votes: "Número de Votos",
                cast_votes_percent: "Porcentaxe de Votos",
                total_votes: "Total de Votantes",
                total_votes_percent: "Participación",
                total_votes_counted: "Total de Votos Contabilizados",
                total_auditable_votes: "Total de Votos Auditable",
                total_valid_votes: "Total de Votos Válidos",
                total_valid_votes_percent: "Porcentaxe de Votos Válidos",
                total_invalid_votes: "Total de Votos Nulos",
                total_invalid_votes_percent: "Porcentaxe de Votos Nulos",
                explicit_invalid_votes: "Votos Nulos Explícitos",
                explicit_invalid_votes_percent: "Porcentaxe de Votos Nulos Explícitos",
                implicit_invalid_votes: "Votos Nulos Implícitos",
                implicit_invalid_votes_percent: "Porcentaxe de Votos Nulos Implícitos",
                blank_votes: "Votos en Branco",
                explicit_blank_votes: "Votos en Branco Explícitos",
                implicit_blank_votes: "Votos en Branco Implícitos",
                blank_votes_percent: "Porcentaxe de Votos en Branco",
                number_of_votes: "Número de Votos",
                winning_position: "Posición Gañadora",
                weight: "Peso",
                preferential: {
                    candidate: "Candidato",
                    winner: "Gañador",
                    eliminated: "Eliminado",
                    round: "Rolda",
                },
                total_declined_to_vote: "Total de votos de renuncia",
                total_blank_ballots: "Total de Papeletas en Branco",
                participation_by_channel: "Participación por canle",
                channel: "Canle",
                channel_online: "En liña",
                channel_kiosk: "Quiosco",
                channel_early_voting: "Votación anticipada",
                channel_telephone: "Teléfono",
                channel_paper: "Papel",
                channel_postal: "Postal",
                channel_in_person: "Presencial",
                acclamation_note: "Elixido por aclamación. Este concurso resolveuse sen votación, polo que non se rexistrou ningún voto.",
            },
            pendingResolutions: {
                round: "Rolda {{round}}",
                tieResolutionRequired: "Resolución de empate necesaria",
                tieResolved: "Empate resolto",
                globalArea: "Global",
                pendingResolutionsHeader: "Resolucións pendentes",
                pendingResolutionStatus: "Resolución pendente",
                resolvedStatus: "Resolto",
                resolutionTitle: "Resolución",
                selectContest: "Seleccione un elemento á esquerda para ver os detalles",
                selectCandidateToAdvance: "Seleccione o candidato a avanzar",
                undoResolution: "Desfacer resolución",
                applyResolutions: "Aplicar resolucións e recalcular",
                submitSuccess: "Resolucións enviadas. O escrutinio está a retomarse...",
                submitError: "Erro ao enviar as resolucións. Por favor, ténteo de novo.",
                filter: "Filtrar",
                save: "Gardar",
                pendingApplyStatus: "Cálculo pendente",
                filterElection: "Elección",
                filterContest: "Concurso",
                filterArea: "Área",
                filterStatusLabel: "Estado",
                clearFilters: "Borrar filtros",
                candidateWithVotes: "{{name}} ({{votes}} votos)",
                candidateWithVotesAndPercent: "{{name}} ({{votes}} votos, {{percent}}%)",
                tieInfoTitle: "Escrutinio pausado por empate sen resolver (Rolda {{round}})",
                tieInfoBody: "Candidatos empatados ({{votes}} votos, {{percent}}%): {{candidates}}. Requírese desempate manual para continuar o escrutinio.",
                tallyResumedTitle: "Escrutinio retomado tras aplicar a resolución",
                tallyResumedBody: "O empate foi resolto o {{date}} por {{user}}",
            },
            chart: {
                votesForCandidates: "Votos polos Candidatos",
                blankVotes: "Votos en Branco",
                invalidVotes: "Votos Inválidos",
                totalVoters: "Total de Votantes",
                nonVoters: "Non Votantes",
            },
            exportAllAreas: "Exportar os resultados de todas as áreas en formato {{format}} para '{{item}}'",
        },
        publish: {
            preview: {
                publicationAreas: "Seleccionar Área para Vista Previa",
                action: "Vista Previa",
                copy: "Copiar ligazón",
                copy_success: "Ligazón de vista previa copiada correctamente",
                copy_error: "Erro ao copiar a ligazón de vista previa",
                success: "Vista previa aberta correctamente",
            },
            header: {
                change: "Cambios a Publicar",
                viewChange: "Ver Publicación",
                history: "Historial de Publicacións",
            },
            action: {
                generateInitializationReport: "Xerar Informe de Inicialización",
                startVotingPeriod: "Iniciar Votación",
                startKioskVoting: "Iniciar Votación en Quiosco",
                startOnlineVoting: "Iniciar Votación en Liña",
                startEarlyVoting: "Iniciar Votación Anticipada",
                startTelephoneVoting: "Iniciar Votación Telefónica",
                stopVotingPeriod: "Detener Votación",
                stopOnlineVoting: "Detener Votación en Liña",
                stopEarlyVoting: "Detener Votación Anticipada",
                stopTelephoneVoting: "Detener Votación Telefónica",
                stopKioskVotingPeriod: "Detener Votación en Quiosco",
                pauseVotingPeriod: "Pausar Votación",
                pauseKioskVoting: "Pausar Votación en Quiosco",
                pauseOnlineVoting: "Pausar Votación en Liña",
                pauseEarlyVoting: "Pausar Votación Anticipada",
                pauseTelephoneVoting: "Pausar Votación Telefónica",
                generate: "Rexenerar",
                publish: "Publicar Cambios",
                back: "Atrás",
            },
            label: {
                current: "Actual",
                previous: "Publicación Anterior",
                publication: "Publicación",
                diff: "Cambios para Publicar",
            },
            empty: {
                header: "Aínda non hai Publicación.",
                action: "Xerar Publicación",
            },
            forbidden: {
                header: "Non se pode Publicar ata que a Cerimonia de Chaves estea completa.",
            },
            dialog: {
                title: "Confirmar Acción",
                info: "Fixeches clic nunha acción sensible, polo que necesitamos que confirmes para continuar",
                initializationInfo: "Estás a piques de xerar o informe de inicialización. ¿Estás seguro de que queres continuar?",
                startInfo: "Estás a piques de iniciar o período de votación. ¿Estás seguro de que queres continuar?",
                stopInfo: "Estás a piques de deter o período de votación. ¿Estás seguro de que queres continuar?",
                kioskStopInfo: "Estás a piques de deter o período de votación en quiosco. ¿Estás seguro de que queres continuar?",
                pauseInfo: "Estás a piques de pausar o período de votación. ¿Estás seguro de que queres continuar?",
                publishInfo: "Estás a piques de xerar unha publicación. ¿Estás seguro de que queres continuar?",
                ok: "Confirmar",
                ko: "Cancelar",
                error: "Erro ao cargar a publicación de papeletas",
                error_publish: "Erro ao publicar a publicación de papeletas",
                error_capacity: "Erro ao xerar o estilo de papeleta: {{message}}",
                error_status: "Erro ao cambiar o estado da publicación de papeletas",
                error_preview: "Erro ao previsualizar a publicación",
                diff: "Renderizar todos os cambios pode facer que a páxina non responda. ¿Estás seguro de que queres continuar?",
                confirmation: "A acción que estás a piques de realizar é sensible e require confirmación. Por favor, introduce o teu contrasinal para continuar con {{action}}.",
            },
            notifications: {
                generated: "Papeleta xerada",
                published: "Papeleta publicada",
                change_status: "Estado da elección cambiado",
            },
        },
        emailEditor: {
            subject: "Asunto do Correo",
            tabs: {
                plaintext: "Corpo de Texto Simple",
                richtext: "Corpo de Texto Enriquecido",
            },
        },
        sendCommunication: {
            send: "Enviar",
            title: "Enviar Notificación",
            subtitle: "Enviar unha notificación aos votantes.",
            sendButton: "Enviar Notificación",
            voters: "Audiencia",
            schedule: "Programar",
            nowInput: "Enviar agora",
            dateInput: "Data e hora para comezar a enviar notificacións",
            chooseDate: "Por favor, escolle unha data",
            languages: "Idiomas",
            smsMessage: "Mensaxe SMS",
            errorSending: "Erro ao enviar a notificación: {{error}}",
            successSending: "Notificación programada/enviada correctamente",
            method: "Método do Modelo",
            type: "Tipo de Comunicación",
            alias: "Alias do Modelo",
            votersSelection: {
                ALL_USERS: "Todos",
                NOT_VOTED: "Os que aínda non votaron",
                VOTED: "Os que xa votaron",
                SELECTED: "A {{total}} {{voters}} seleccionados",
            },
            path: {
                users: "usuarios",
                voters: "votantes",
            },
            methodTitle: "Modelo de Comunicación",
            communicationMethod: {
                EMAIL: "Correo",
                SMS: "SMS",
            },
            communicationType: {
                CREDENTIALS: "Credenciais",
                BALLOT_RECEIPT: "Recibo da Papeleta",
            },
            email: {
                subject: "Asunto",
            },
        },
        tallysheet: {
            title: "Urnas",
            subtitle: "Urnas dixitalizadas por canal",
            createTallySuccess: "Acta de Escrutinio gardada",
            createTallyError: "Erro ao gardar a Acta de Escrutinio",
            createTallyErrorSameKindExists: "A folla de reconto xa existe para este concurso co mesmo canal e área",
            allFieldsRequired: "Todos os campos son obrigatorios",
            header: {
                change: "Cambios a Publicar",
                viewChange: "Ver Publicación",
                history: "Historial de Publicacións",
            },
            action: {
                start: "Iniciar Elección",
                stop: "Detener Elección",
                pause: "Pausar",
                generate: "Rexenerar",
                publish: "Publicar Cambios",
                back: "Atrás",
            },
            inputError: {
                totalValidDoesNotMatch: "Os votos de candidatos ({{candidateVotesSum}}) deben estar entre {{lowerBound}} e {{upperBound}} segundo as regras de votación desta contenda ({{nonBlankValidVotes}} votos válidos non en branco × ata {{maxMarks}} marcas por papeleta)",
                censusTooSmall: "O total de votos ({{totalVotes}}) non pode ser maior que o censo ({{census}})",
                totalInvalidDoesNotMatch: "O total de votos non válidos ({{totalInvalid}}) debe ser igual aos votos non válidos implícitos ({{implicitInvalid}}) máis os votos non válidos explícitos ({{explicitInvalid}})",
                totalVotesDoesNotMatch: "O total de votos ({{totalVotes}}) debe ser igual ao total de votos válidos ({{totalValidVotes}}) máis o total de votos non válidos ({{totalInvalid}})",
                unknownCountingAlgorithm: "O algoritmo de reconto desta contenda ({{countingAlgorithm}}) non se recoñece, polo que non se pode determinar o número permitido de votos de candidatos. Revise a configuración da contenda.",
                blankBallotsInconsistent: "As Papeletas en Branco deben ter o mesmo valor en todas as follas de escrutinio desta urna",
                blankBallotsOutOfBounds: "O valor de Papeletas en Branco está fóra do rango que implican os reconto de votos en branco por candidatura desta urna",
            },
            label: {
                area: "Área",
                channel: "Canle",
                total_votes: "Total de Votos",
                total_valid_votes: "Total de Votos Válidos",
                total_invalid: "Total de Votos Nulos",
                explicit_invalid: "Votos Nulos Explícitos",
                implicit_invalid: "Votos Nulos Implícitos",
                total_blank_votes: "Votos en Branco",
                blank_ballots: "Papeletas en Branco",
                census: "Censo",
            },
            common: {
                tallyCeremony: {
                    manage: "Xestionar Cerimonia de Escrutinio",
                    view: "Ver Cerimonia de Escrutinio",
                    cancel: "Cancelar Cerimonia de Escrutinio",
                    addKey: "Engadir Chave de Escrutinio",
                },
                edit: "Editar",
                confirm: "Confirmar",
                back: "Atrás",
                next: "Seguinte",
                cancel: "Atrás",
                data: "Datos",
                title: "Acta de Escrutinio",
                subtitle: "Configuración da Acta de Escrutinio.",
                candidates: "Candidatos",
                save: "Gardar",
                approve: "Aprobar",
                disapprove: "Desaprobar",
                show: "Amosar",
                add: "Engadir",
                versions: "Versións",
                warningDisapprove: "Está seguro de desaprobar esta Folla de Reconto?",
                warningApprove: "Está seguro de aprobar esta Folla de Reconto?",
            },
            empty: {
                header: "Aínda non hai Acta de Escrutinio.",
                action: "Xerar Acta de Escrutinio",
                add: "Engadir",
            },
            breadcrumbSteps: {
                start: "Inicio",
                edit: "Editar",
                confirm: "Confirmar",
                view: "Ver",
            },
            table: {
                area: "Área",
                contest: "Concurso",
                approvedVersion: "Versión aprobada",
                latestVersion: "Última versión",
                labels: "Etiquetas",
                annotations: "Anotacións",
            },
            versionsTable: {
                title: "Versións da urna",
                version: "Versión",
                createdBy: "Creado por",
                reviewedBy: "Revisado por",
                createdAt: "Creado o",
                reviewedAt: "Revisado o",
                sourceImport: "Importación de orixe",
                importStatus: "Estado da importación",
                openImport: "Abrir importación",
                sourceFile: "Ficheiro de orixe",
            },
            message: {
                reviewError: "Erro ao revisar a acta de escrutinio",
                reviewSuccess: "Acta de escrutinio revisada",
            },
        },
        application: {
            import: {
                title: "Importar Aplicaciones",
                subtitle: "Importar datos de aplicaciones",
                paragraph: "Importa aplicaciones usando un archivo de hoja de cálculo en formato de valores separados por comas (CSV). Descarga un archivo CSV de ejemplo aquí.",
                messages: {
                    success: "Aplicaciones importadas con éxito",
                    error: "Error al importar las aplicaciones",
                },
            },
            export: {
                title: "Exportar Aplicaciones",
                subtitle: "Exportar datos de aplicaciones",
                button: "Exportar",
                paragraph: "Exporta aplicaciones usando un archivo de hoja de cálculo en formato de valores separados por comas (CSV).",
                messages: {
                    success: "Aplicaciones exportadas con éxito",
                    error: "Error al exportar las aplicaciones",
                },
            },
        },
        template: {
            noPermissions: "Non tes permiso para acceder aos modelos.",
            title: "Modelos",
            subtitle: "Lista de modelos",
            chooseMethods: "Escoller Métodos",
            default: "Usar modelo predeterminado",
            empty: {
                title: "Aínda non hai Modelo",
                subtitle: "¿Queres crear un?",
            },
            action: {
                createOne: "Crear Modelo",
            },
            create: {
                title: "Crear un Modelo",
                success: "Modelo creado",
                error: "Erro ao crear o Modelo",
            },
            update: {
                success: "Modelo actualizado",
                error: "Erro ao actualizar o Modelo",
            },
            edit: {
                title: "Editar un Modelo",
            },
            form: {
                smsMessage: "Mensaxe SMS",
                document: "Documento",
                pdfOptions: "Opciones de PDF",
                name: "Nome do Modelo",
                alias: "Alias do Modelo",
                type: "Tipo",
                communicationMethod: "Método",
                reportOptions: "Opciones de Informe",
            },
            type: {
                CREDENTIALS: "Credenciales",
                INITIALIZATION_REPORT: "Informe de Inicialización",
                ELECTORAL_RESULTS: "Resultados Electorales",
                BALLOT_IMAGES: "Imágenes de Boletas",
                BALLOT_RECEIPT: "Recibo de Voto",
                ACTIVITY_LOGS: "Registros de Actividades",
                MANUAL_VERIFICATION: "Verificación Manual",
                PARTICIPATION_REPORT: "Informe de Participación",
            },
            method: {
                email: "Correo",
                sms: "SMS",
                document: "Documento",
            },
            import: {
                title: "Importar Plantillas",
                subtitle: "Importar datos de plantillas",
                paragraph: "Importa plantillas usando un archivo de hoja de cálculo en formato de valores separados por comas (CSV). Descarga un archivo CSV de ejemplo aquí.",
            },
        },
        materials: {
            createMaterialSuccess: "Material de soporte creado",
            createMaterialError: "Erro ao crear o material de soporte",
            updateMaterialSuccess: "Material de soporte actualizado",
            updateMaterialError: "Erro ao actualizar o material de soporte",
            common: {
                title: "Material de Soporte",
                subtitle: "Introducir datos do material de soporte.",
            },
            error: {
                title: "O título é obrigatorio",
                document: "O documento é obrigatorio",
            },
            fields: {
                isHidden: "Está Oculto",
                publicUrl: "URL Pública",
            },
            empty: {
                header: "Aínda non hai material de apoio",
                action: "Xerar material de apoio",
            },
        },
        widget: {
            logs: "Rexistros",
        },
        settings: {
            countries: {
                title: "Bloqueo de Países",
                votingDescription: "Elixe abaixo os países dos que queres bloquear a votación.",
                enrollmentDescription: "Elixe abaixo os países dos que queres bloquear o rexistro.",
                error: {
                    errorSaving: "Erro ao gardar a lista de países",
                },
            },
            backupRestore: {
                title: "Copia de seguridad / Restaurar configuración del inquilino",
                backup: {
                    label: "Respaldo",
                    subtitle: "Copia de seguridad de las configuraciones del inquilino",
                },
                restore: {
                    label: "Restaurar",
                    subtitle: "Restaurar la configuración del inquilino",
                    title: "Importar configuraciones del inquilino",
                    paragraph: "Importar configuraciones del inquilino, configuraciones de Keycloak, roles y datos de permisos usando una carpeta comprimida.",
                    tenantConfigOption: "Importar configuraciones del inquilino",
                    keycloakConfigOption: "Importar configuraciones de Keycloak",
                    RolesConfigOption: "Importar configuraciones de roles y permisos",
                },
            },
            previewScreen: {
                label: "Vistas Previas",
                noContent: "Non se atoparon vistas previas",
                table: {
                    title: "Vistas previas externas",
                    description: "Un rexistro das vistas previas de estilos de papeleta xeradas mediante peticións externas",
                    requestedBy: "Solicitado por",
                    document: "Documento",
                    url: "URL",
                },
            },
            languages: {
                default: "Idioma predeterminado",
            },
        },
        approvalsScreen: {
            column: {
                status: "Estado",
                id: "ID",
                applicantId: "ID do Solicitante",
                verificationType: "Tipo de Verificación",
                createdAt: "Creado o",
                updatedAt: "Actualizado o",
                verified_by: "Aprobado Por",
            },
            approvalRequest: "Solicitud de Aprobación",
            title: "Votantes",
            subtitle: "Atopar votantes coincidentes",
            approve: {
                body: "¿Estás seguro de que queres aprobar este votante? Esta acción non é reversible.",
            },
            reject: {
                label: "Rechazar la solicitud",
                confirm: "¿Estás seguro de que deseas rechazar a este votante? Esta acción no es reversible.",
                message: "Escribe aquí el motivo del rechazo",
                rejectReason: "Motivo del rechazo",
                messageRequired: "Se requiere un mensaje de rechazo para la opción 'Otro'",
                reasons: {
                    "undefined": "-",
                    "insufficient-information": "Datos Faltantes",
                    "no-matching-voter": "Votante no Coincidente",
                    "voter-already-approved": "Ya Aprobado",
                    "other": "Otro",
                },
            },
            notifications: {
                approveError: "Error al aprobar al votante",
                approveSuccess: "Votante aprobado",
                rejectError: "Error al rechazar al votante",
                rejectSuccess: "Votante rechazado",
                VoterApprovedAlready: "El votante ya está aprobado.",
            },
            export: {
                success: "La exportación de aplicaciones se completó con éxito",
                error: "Error al exportar las aplicaciones",
            },
        },
        monitoringDashboardScreen: {
            voters: {
                title: "Votantes",
                enrolledOverseasVoters: "Votantes Inscritos en el Extranjero",
                approvalStatus: "Estado de Aprobación: Votantes Aprobados/Desaprobados",
                manuallyApproval: "Votantes Aprobados/Desaprobados Manualmente",
                automaticallyApproval: "Votantes Aprobados/Desaprobados Automáticamente",
                authenticatedVoters: "Votantes Autenticados",
                invalidUserErrors: "Errores de Usuario Inválido:",
                invalidPasswordErrors: "Errores de Contraseña Inválida:",
            },
            polls: {
                title: "Encuestas",
                initializedSystems: "Publicaciones con Sistemas Inicializados",
                votingOpened: "Publicaciones con Votación Abierta",
                votingClosed: "Publicaciones con Votación Cerrada",
                votingStarted: "Publicaciones con Votación Iniciada",
                voterTurnout: "Participación de los Votantes",
            },
            tally: {
                title: "Conteo",
                activeVotesCounting: "Publicaciones con Conteo de Votos Activo",
                generatedERs: "Publicaciones con ERs Generados",
                transmittedResults: "Publicaciones con Resultados Transmitidos",
            },
            testing: {
                title: "Pruebas",
                testElectionVoterCount: "Conteo de Votantes en Elección de Prueba",
            },
        },
        certificateAuthorities: {
            title: "Certificados",
            subtitle: "Autoridades de certificación (CA) de confianza para este evento electoral. As CA importadas úsanse para validar os certificados dos votantes.",
            importButton: "Importar certificados",
            type: {
                root: "Raíz",
                intermediate: "Intermedio",
            },
            expiry: {
                expired: "Caducado",
                expiringSoon: "Próximo a caducar",
                valid: "Válido",
            },
            columns: {
                commonName: "Nome común",
                type: "Tipo",
                issuerCn: "CN do emisor",
                notBefore: "Válido desde",
                notAfter: "Caduca",
                fingerprint: "Pegada SHA256",
            },
            importDialog: {
                title: "Importar autoridades de certificación",
                subtitle: "Importar un ou máis certificados CA desde un ficheiro PEM",
                description: "Seleccione un ficheiro PEM que conteña un ou máis certificados. Admítense paquetes — cada certificado impórtase individualmente.",
                selectFile: "Seleccionar ficheiro PEM",
                fileLoaded: "Ficheiro cargado ({{bytes}} bytes)",
                importButton: "Importar",
            },
            notify: {
                importSuccess: "Importáronse {{inserted}} certificado(s).",
                importSkipped: "{{count}} omitido(s) (xa presentes).",
                importErrors: "Problemas na importación: {{errors}}",
                importError: "Erro ao importar: {{error}}",
                deleteSuccess: "Certificado eliminado.",
                deleteError: "Erro ao eliminar o certificado.",
                exportSuccess: "Certificado(s) exportado(s) correctamente.",
                exportError: "Erro ao exportar os certificados.",
            },
            exportDialog: {
                title: "Exportar autoridades de certificación",
                description: "Está a punto de exportar {{amount}} certificado(s).",
                all: "todos",
            },
            deleteDialog: {
                description: "¿Está seguro de que desexa eliminar {{count}} certificado(s)?",
            },
            emptyHeader: "Non se importaron autoridades de certificación para este evento electoral.",
            fileReadError: "Erro ao ler o ficheiro.",
            viewDialog: {
                title: "Detalles da autoridade de certificación",
                subject: "Asunto",
                issuer: "Emisor",
                serialNumber: "Número de serie",
                pemContent: "Contido PEM",
            },
            confirmDelete: "Eliminar autoridade de certificación",
            confirmDeleteDescription: '¿Está seguro de que quere eliminar o certificado "{{name}}" (pegada: {{fingerprint}})?',
        },
    },
};
export default galegoTranslation;
